import { Component, OnInit, ViewChild, OnDestroy, HostListener, ElementRef } from '@angular/core';
import { GridRefreshComponent } from '../core/grid/grid-refresh/grid-refresh.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomTooltipComponent } from '../core/custom-tooltip/custom-tooltip.component';
import { GriddataService } from '../services/griddata.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ExcelService } from '../services/excel.service';
import { OSPStateService } from '../services/osp-state.service';
import { forkJoin, Subscription } from 'rxjs';
import { FluctuationAllowanceService } from '../services/fluctuation-allowance/fluctuation-allowance.service';
import { LookupService } from '../services/lookup/lookup.service';
import {
  checkInvAccess,
  resetSortingAndFilters,
  successMessage,
  validateVanningDates,
  warningMessage,
} from '../constants';
import { logErrors } from '../shared/logger';
import { MatDialogConfig } from '@angular/material/dialog';
import { ColDef, IDetailCellRendererParams } from 'ag-grid-community';
import { PartsInventoryService } from '../services/parts-inventory/parts-inventory.service';
import { DeleteBreaksComponent } from '../configuration-shifts/breaks-detailview/delete-breaks/delete-breaks.component';
import { ActivatedRoute, Router } from '@angular/router';
import * as mm from 'moment-timezone';
import { HeaderCheckboxComponent } from '../core/grid/header-checkbox/header-checkbox.component';
import { RowCheckboxComponent } from '../core/grid/row-checkbox/row-checkbox.component';
import { ConfirmCancelDailogComponent } from '../core/confirm-cancel-dailog/confirm-cancel-dailog.component';
import { StockingPaceServiceService } from '../services/stocking-pace-service.service';
import { UpdatedPartscountComponent } from './parts-group/updated-parts-count.component';
import * as XLSX from 'xlsx';
import { PartstCountService } from '../services/parts-count/partsCount.service';
import { DeletePctBtnCellRender } from './parts-group/delete-pct-btn-cell-render';
import { DefaultService } from '../services/default.service';
import { jsPDF } from 'jspdf';
import { UpdateChildPartscountComponent } from './parts-group/update-child-parts-count.component';
import { SaveChildPartscountComponent } from './parts-group/save-child-parts-count.component';

@Component({
  selector: 'app-parts-count',
  templateUrl: './parts-count.component.html',
  styleUrls: ['./parts-count.component.scss']
})
export class PartsCountComponent implements OnInit, OnDestroy {
  namcValue = localStorage.getItem('namcvalue');
  userName = localStorage.getItem('UserName');
  showDownloadUploadButtons: boolean = true;
  count = 0;
  rowData = [];
  tempRowData = [];
  @ViewChild('osPartsGrid') osPartsGrid;
  @ViewChild('upload') fileInput: ElementRef<HTMLInputElement>;
  columnDefsMaster;
  rowSelection;
  user: string;
  namcName: string;
  userRole: any;
  warningMessage = '';
  warningMessageUpload = '';
  offset: number = 0;
  dataCount: number = 0;
  modalComponent = 'modal-component';
  gridOptions;
  paginationPageSize;
  paginationNumberFormatter;
  pagination = 'true';
  context: any;
  editType;
  suppressClickEdit = true;
  tooltipShowDelay = 0;
  frameworkComponents = { customTooltip: CustomTooltipComponent };
  headerCheckboxChecked: boolean = false;
  partDesc = 'Part Description';
  dockListTo: any = [];
  dockListCopy: any = [];
  dockListToCopy: any = [];
  editApiDefaultLimit = 200;
  timesEditApiCalled: number = 0;
  editApiStartPosition: number = 0;
  editApiEndPosition: number = this.editApiDefaultLimit;
  editEnabled = false;
  freezeStatus = false;
  filter = false;
  showToggleAll = false;
  showClear = true;
  disablePartscontrol: boolean;
  disableKanban: boolean;
  rowdata: any = [];
  partNoList: any = [];
  // kanbanList: any = [];
  // specialistList: any = [];
  // Dropdowns
  selectedKanban: any = [];
  // selectedPartsControl: any = [];
  selectedDock: any = [];
  selectedContainer: any = [];
  selectedModule: any = [];
  selectedSpecialist: any = [];
  selectedGetAddress: any = [];
  selectedGetGroupName: any = [];
  effectiveFrom: any;
  effectiveTo: any;
  adjustSubscription$: Subscription;

  // Dropdown Options
  kanbanList: any = [];
  partsControlList: any = [];
  partNoListAdd: any = [];
  dockList: any = [];
  containerList: any [];
  moduleList: any [];
  dockListForpopup: any = [];
  specialistList: any = [];
  // policyNameList: any = [];
  getAddressList : any = [];
  getGroupName : any = [];
  getGroupNameCopy: any = [];
  qpcforParts: any = [];
  rowCount = 0;
  count1 = 0;
  isEditMode = false;
  successMessage = '';

  kanbanSelected = 1;

  easternDate: any;
  defaultPageSize: any = 100000;
  itContact: any;

  //upload
  uploadError: boolean;
  uploadEnabled: boolean;
  files: any[];
  fileBuffer: any;
  justFileName: any;
  allowedFilesize: number;
  uploading: boolean = false;
  exportData: any;
  validating: boolean;
  loading: boolean;
  //default button
  showDefaultButton: boolean = false;
  displayNames = {
    kanban: 'Kanban',
    item_id: 'PartNo',
    part_description:'DESCRIPTION',
    address:'PC ADDRESS',
    order_lot:'ORDERLOT',
    apccapacity:'APC',
    container_renban: 'CONTAINER',
    module_number: 'MODULE',
    supplier_code: 'SUPPLIER',
    dock: 'DOCK',
  };
  dateFormat = 'MM/DD/YYYY';
  newDate = String(mm().tz('US/Michigan').format(this.dateFormat)).substring(0, 10);
  errorDetails : any[];
  partsCountUserArray : any[]
  defaultArr: any[];
  planned_stocking_date: any;
  access;
  accessEdit = false;
  constructor(
    private readonly spinner: NgxSpinnerService,
    private readonly OspService: PartsInventoryService,
    private readonly excelService: ExcelService,
    private readonly gridDataService: GriddataService,
    public dialog: MatDialog,
    private readonly stateService: OSPStateService,
    private readonly flalService: FluctuationAllowanceService,
    private readonly lookupService: LookupService,
    private router: Router,
    private readonly stockingService: StockingPaceServiceService,
    private readonly partsCountService: PartstCountService,
    private route: ActivatedRoute,
    private readonly defaultService : DefaultService
  ) {
    this.context = {
      componentParent: this,
    };
  }
  numberComparator(number1, number2) {
    return number1 - number2;
  }

  dateComparator(date1, date2) {
    function monthToNum(date) {
      if (date === undefined || date === null) {
        return null;
      }

      const newDate: Date = new Date(date);

      const yearNumber = newDate.getFullYear();
      const monthNumber = newDate.getMonth();
      const dayNumber = newDate.getDate();
      const hoursNumber = newDate.getHours();
      const minutesNumber = newDate.getMinutes();

      const result =
        yearNumber * 10000 +
        monthNumber * 100 +
        dayNumber +
        hoursNumber * 60 +
        minutesNumber * 10;
      return result;
    }
    // To be used inside filter params when using date filter
    const date1Number = monthToNum(date1);
    const date2Number = monthToNum(date2);

    if (date1Number === null && date2Number === null) {
      return 0;
    }
    if (date1Number === null) {
      return -1;
    }
    if (date2Number === null) {
      return 1;
    }

    return date1Number - date2Number;
  }
  fileName: string = '';
  actualFileName : string = '';
  // access1;
  headersSameAsUI = [
    'KANBAN',
    'PARTNO',
    'DESCRIPTION',
    'COUNT BY', //order_lot
    // 'MAN',
    'PC ADDRESS',
    'ORDERLOT',
    'BOX TYPE',
    // 'Count',
    'SAFETY',
    'COUNT BOXES',
    'CONTAINER',
    'MODULE',
    'SUPPLIER',
    'DOCK',
    // 'Comment',
    // 'User',
    // 'Updated DT',
  ];
  onPageSizeChanged() {
    if (this.gridOptions?.api) {
      this.gridOptions.api.paginationSetPageSize(
        Number(this.paginationPageSize)
      );
    }
  }

  setPageSizeToAll(pageSize?) {
    this.paginationPageSize = this.rowData.length;
    if (pageSize) {
      this.paginationPageSize = 0;
      this.rowData.length = 0;
    }
    this.onPageSizeChanged();
  }

  ngOnDestroy(): void {
    this.adjustSubscription$.unsubscribe();
  }

  public columnDefs: ColDef[]
  public defaultColDef;
  public groupDefaultExpanded = 1;
  public detailCellRendererParams

  ngOnInit(): void {
    this.access = checkInvAccess();
    this.accessEdit = this.access?.functionalityAccess?.edit || false;

    this.detailCellRendererParams = {
      detailGridOptions: {
        columnDefs: [
          {
            headerName: '',
            field: 'delete',
            // width: 0,
            flex: 0.4,
            cellRenderer: DeletePctBtnCellRender,
            cellRendererParams: {
              clicked: (field?: any) => {
                this.deleteButton(field)
              },
            },
            suppressMovable: true,
            // cellStyle: { cursor: 'pointer' },
            // headerTooltip: 'Count DT',
            // tooltipField: 'part_no',
          },
          {
            headerName: 'Count DT',
            field: 'countdate',
            width: 10,
            headerTooltip: 'Count DT',
            tooltipField: 'countdate',
            sortable: false,
            floatingFilter: false,
            suppressMovable: true,
          },
          {
            headerName: 'Lineoff DT',
            field: 'lineoff_date',
            width: 10,
            headerTooltip: 'Lineoff DT',
            tooltipField: 'lineoff_date',
            sortable: false,
            floatingFilter: false,
            suppressMovable: true,
          },
          {
            headerName: 'Stocking DT',
            field: 'planned_stocking_datetime',
            width: 10,
            headerTooltip: 'dock',
            tooltipField: 'planned_stocking_datetime',
            sortable: false,
            floatingFilter: false,
            suppressMovable: true,
          },
          {
            headerName: 'Renban',
            field: 'container_renban',
            width: 10,
            headerTooltip: 'container_renban',
            tooltipField :'container_renban',
            sortable: false,
            floatingFilter: false,
            suppressKeyboardEvent: (params) => {
              const navigationKeys = ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Enter'];
              return !navigationKeys.includes(params.event.key);
            },
            floatingFilterComponentParams: { suppressFilterButton: false },
            suppressMovable: true,
            cellRendererFramework: UpdateChildPartscountComponent,
            cellRendererParams: { column: 'renban_number' },
          },
          {
            headerName: 'Module',
            field: 'module_number',
            width: 10,
            headerTooltip: 'Module',
            tooltipField:'module_number',
            sortable: false,
            floatingFilter: false,
            suppressMovable: true,
            suppressKeyboardEvent: (params) => {
              const navigationKeys = ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Enter'];
              return !navigationKeys.includes(params.event.key);
            },
            floatingFilterComponentParams: { suppressFilterButton: false },
            cellRendererFramework: UpdateChildPartscountComponent,
            cellRendererParams: { column: 'module_code' },
          },
          {
            headerName: 'Supplier',
            field: 'supplier_code',
            width: 10,
            hide: true,
            headerTooltip: 'Supplier',
            tooltipField:'supplier_code',
            sortable: false,
            floatingFilter: false,
            suppressMovable: true,
          },
          {
            headerName: 'Count',
            field: 'count',
            flex: 0.5,
            headerTooltip: 'Count',
            tooltipField:'count',
            sortable: false,
            floatingFilter: false,
            suppressMovable: true,
            cellRendererFramework: UpdateChildPartscountComponent,
            cellRendererParams: { column: 'count_number' },
            suppressKeyboardEvent: (params) => {
              const navigationKeys = ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Enter'];
              return !navigationKeys.includes(params.event.key);
            },
            valueGetter: (params: any): number | null => {
              // Handling the logic for 'valueGetter' with a conditional return
              if (!this.editEnabled || !params.data.rowCheckBox) {
                return params.data.count_number ? params.data.count_number.value : null;
              } else {
                const value = params.data.orderLot?.value ?? params.data.count_number?.value;
                return value ? parseFloat(value) : null;  // Ensure numeric value is returned
              }
            },
          },
          {
            headerName: 'Safety',
            field: 'apccapacity',
            flex: 0.5,
            headerTooltip: 'Safety',
            tooltipField:'apccapacity',
            sortable: false,
            floatingFilter: false,
            suppressMovable: true,
            suppressKeyboardEvent: (params) => {
              const navigationKeys = ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Enter'];
              return !navigationKeys.includes(params.event.key);
            },
            cellRendererFramework: UpdateChildPartscountComponent,
            cellRendererParams: { column: 'apc_value' },
          },
          {
            headerName: 'Comment',
            field: 'comment',
            width: 1,
            hide: true,
            headerTooltip: 'Comment',
            tooltipField:'comment'
          },
          {
            headerName: '',
            field: 'save',
            // width: 0,
            flex: 0.4,
            cellRenderer: SaveChildPartscountComponent,
            cellRendererParams: {
              clicked: (field?: any) => {
                this.onSaveMode(field)
              },
            },
            suppressMovable: true,
            // cellStyle: { cursor: 'pointer' },
            // headerTooltip: 'Count DT',
            // tooltipField: 'part_no',
          },

        ],
        defaultColDef: {
          flex: 1,
        },
        // groupDefaultExpanded: 1,
        // masterDetail: true,
        // detailRowHeight: 0.5,
      },
      
      // Ensure getDetailRowData is inside detailCellRendererParams
      getDetailRowData: (params) => {
        // Make sure params.data.children is valid and contains the correct detail data
        if (params.data && params.data.children) {
          params.successCallback(params.data.children);
        } else {
          params.successCallback([]);
        }
      },
    };

    this.columnDefsMaster = [
      
      {
        headerName: '',
        // cellRendererFramework: PartsActionsComponent,
        floatingFilterComponentFramework: GridRefreshComponent,
        field: 'actions',
        width: 50,
        sortable: false,
        floatingFilter: true,
        pinned: 'left',
        headerComponentParams: {
          headerChecked: this.headerCheckboxChecked,
        },
        headerComponentFramework: HeaderCheckboxComponent,
        cellRendererFramework: RowCheckboxComponent,

      },
      // {
      //   headerName: 'Dock',
      //   field: 'dock',
      //   width: 80,
      //   floatingFilter: true,
      //   tooltipField: 'dock',
      //   headerTooltip: 'Dock',
      //   cellRenderer: "agGroupCellRenderer"
      // },
      {
        headerName: 'Kanban',
        field: 'kanban',
        sortable: true,
        width: 90,
        floatingFilter: true,
        tooltipField: 'kanban',
        headerTooltip: 'Kanban',
        cellRenderer: "agGroupCellRenderer"
        // valueGetter: function (params) {
        //   if (params.data.description === 'undefined') {
        //     return '';
        //   } else {
        //     return params.data.description;
        //   }
        // },

      },
      {
        headerName: 'Part No',
        field: 'item_id',
        width: 130,
        floatingFilter: true,
        tooltipField: 'item_id',
        headerTooltip: 'Part No',
      },
      
      {
        headerName: 'Address',
        // field: 'address',
        sortable: true,
        width: 120,
        floatingFilter: true,
        headerTooltip: 'Address',
        tooltipField: 'address',
        valueGetter: (params) => {
          return params.node.data.address; // <--- what to show in the group column
        },
      },
      {
        headerName: 'Count By',
        field: 'tobecounted_date',
        sortable: true,
        width: 110,
        floatingFilter: true,
        headerTooltip: 'Count By',
        // filter: 'agNumberColumnFilter',
        // floatingFilterComponentParams: { suppressFilterButton: false },
        // filterParams: {
        //   numberParser: (text) => {
        //     return text === null ? null : parseFloat(text.replace(',', '.'));
        //   },
        // },
      },
      {
        headerName: 'Man',
        field: 'manually_added',
        sortable: true,
        width: 90,
        floatingFilter: true,
        headerTooltip: 'Man',
        hide: true,
        // filter: 'agNumberColumnFilter',
        // floatingFilterComponentParams: { suppressFilterButton: false },
        // filterParams: {
        //   numberParser: (text) => {
        //     return text === null ? null : parseFloat(text.replace(',', '.'));
        //   },
        // },
      },
      {
        headerName: 'Count*',
        field: 'orderLot',
        sortable: true,
        width: 100,
        headerTooltip: 'Count*',
        floatingFilterComponentParams: { suppressFilterButton: false },
        filter: 'agNumberColumnFilter',
        floatingFilter: true,
        cellRendererFramework: UpdatedPartscountComponent,
        cellRendererParams: { column: 'count_number' },
        // suppressKeyboardEvent: (params) => {
        //   const navigationKeys = ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Enter'];
        //   return !navigationKeys.includes(params.event.key);
        // },
        valueGetter: (params: any): number | null => {
          // Handling the logic for 'valueGetter' with a conditional return
          if (!this.editEnabled || !params.data.rowCheckBox) {
            return params.data.count_number ? params.data.count_number.value : null;
          } else {
            const value = params.data.orderLot?.value ?? params.data.count_number?.value;
            return value ? parseFloat(value) : null;  // Ensure numeric value is returned
          }
        },
        filterParams: {
          numberParser: (text: string | null): number | null => {
            if (text === null || text === '') return null;
            const parsed = parseFloat(text.replace(',', '.'));
            return isNaN(parsed) ? null : parsed; // Handle invalid numbers safely
          },
        },
      },
      {
        headerName: 'Safety',
        field: 'apccapacity',
        sortable: true,
        width: 100,
        floatingFilter: true,
        headerTooltip: 'Safety',
        filter: 'agNumberColumnFilter',
        floatingFilterComponentParams: { suppressFilterButton: false },
        filterParams: {
          numberParser: (text) => {
            return text === null ? null : parseFloat(text.replace(',', '.'));
          },
        },
        cellRendererFramework: UpdatedPartscountComponent,
        cellRendererParams: { column: 'apc_value' },
        valueGetter: (params) => {
          if (!this.editEnabled || !params.data.rowCheckBox) {
            return params.data.apc_value ? params.data.apc_value.value : null;
          } else {
            const value = params.data.apccapacity?.value ?? params.data.apc_value?.value;

            return value;
          }
        },
      },

      {
        headerName: 'Renban*',
        field: 'containerRenban',
        sortable: true,
        width: 100,
        floatingFilter: true,
        headerTooltip: 'Renban*',
        cellRendererFramework: UpdatedPartscountComponent,
        cellRendererParams: { column: 'renban_number' },
        //valueGetter: (params) => {
          // if (!this.editEnabled || !params.data.rowCheckBox) {
          //   return params.data.renban_number ? params.data.renban_number?.value : null;
          // } else {
          //   const value = params.data.containerRenban?.value ?? params.data.renban_number?.value;

          //   return value;
          // }
        //},
      },
      {
        headerName: 'Module*',
        field: 'moduleNumber',
        sortable: true,
        width: 100,
        floatingFilter: true,
        headerTooltip: 'Module*',
        cellRendererFramework: UpdatedPartscountComponent,
        cellRendererParams: { column: 'module_code' },
        //valueGetter: (params) => {
          // if (!this.editEnabled || !params.data.rowCheckBox) {
          //   return params.data.module_code ? params.data.module_code.value : null;
          // } else {
          //   const value = params.data.moduleNumber?.value ?? params.data.module_code?.value;

          //   return value;
          // }
        //},
      },
      {
        headerName: 'Supplier',
        field: 'supplier_code',
        sortable: true,
        width: 130,
        hide: true,
        floatingFilter: true,
        headerTooltip: 'Supplier',
        cellRendererFramework: UpdatedPartscountComponent,
        cellRendererParams: { column: 'supplier_number' },
        valueGetter: (params) => {
          if (!this.editEnabled || !params.data.rowCheckBox) {
            return params.data.supplier_number ? params.data.supplier_number.value : null;
          } else {
            const value = params.data.supplier_code?.value ?? params.data.supplier_number?.value;

            return value;
          }
        },
      },
      {
        headerName: 'Comment',
        field: 'comment',
        sortable: true,
        hide: true,
        width: 130,
        floatingFilter: true,
        headerTooltip: 'Comment',
        cellRendererFramework: UpdatedPartscountComponent,
        cellRendererParams: { column: 'comment_data' },
        valueGetter: (params) => {
          if (!this.editEnabled || !params.data.rowCheckBox) {
            return params.data.comment_data;
          } else {
            const value = params.data.comment?.value ?? params.data.comment_data?.value;

            return value;
          }
        },
      },
      {
        headerName: 'Description',
        field: 'part_description',
        sortable: true,
        width: 170,
        floatingFilter: true,
        headerTooltip: 'Description',
        tooltipField: 'part_description',
      },
      {
        headerName: 'User',
        field: 'updated_userid',
        width: 220,
        floatingFilter: true,
        headerClass: 'ag-theme-custom-text-right',
        headerTooltip: 'User',
        tooltipField: 'updated_userid',
      },
      {
        headerName: 'Updated DT',
        field: 'updated_date_time',
        width: 170,
        floatingFilter: true,
        headerClass: 'ag-theme-custom-text-right',
        headerTooltip: 'Updated Date(mm/dd/yyyy hh:mm:ss (Eastern))',
        tooltipField: 'updated_date_time',
      },

    ];

    this.columnDefs = [...this.columnDefsMaster];

    this.setPageSizeToAll(this.defaultPageSize);
    this.rowSelection = 'multiple';
    this.editType = 'fullRow';
    this.gridOptions = this.gridDataService.getGridOptions();
    this.gridOptions.onGridReady = function (params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    };
    this.adjustSubscription$ = this.stateService
      .getNamc()
      .subscribe((observable) => {
        this.initializeData();
      });
  }

  onCellKeyDown(event: any): void {
    let targetRowIndex;
    let node;
    
    if (event.event.key === 'ArrowDown') {
      targetRowIndex = event.rowIndex + 1;
      
      for (let index = targetRowIndex; index < this.rowData.length; index++) {
        node = this.osPartsGrid.gridOptions.api.getDisplayedRowAtIndex(index);
        if (!this.isRowInCurrentPage(index)){
          return;
        }
        if (node.data.checkedEditMode){
          break;
        }
      } 

    } else if (event.event.key === 'ArrowUp'){
      targetRowIndex = event.rowIndex - 1;
      
      for (let index = targetRowIndex; index >= 0; index--) {
        node = this.osPartsGrid.gridOptions.api.getDisplayedRowAtIndex(index);
        //const element = array[index];
        if (!this.isRowInCurrentPage(index)){
          return;
        }
        if (node.data.checkedEditMode){
          break;
        }
        //targetRowIndex = index;
      }
    }else{
      return;
    }  
      if (node){
        const nextComp = this.gridOptions.api.getCellRendererInstances({
          rowNodes: [this.gridOptions.api.getDisplayedRowAtIndex(node.rowIndex)],
          columns: [event.colDef.field] // Make sure this matches your field name
        })[0];
    
        if (nextComp && typeof nextComp.focusInput === 'function') {
          event.api.deselectAll();
          node.setSelected(true);
          nextComp.focusInput();
        }
      }
  }


  isRowInCurrentPage(rowIndex?: number): boolean {
    const currentPage = this.gridOptions.api.paginationGetCurrentPage();
    const pageSize = this.gridOptions.api.paginationGetPageSize();
  
    const startRow = currentPage * pageSize;
    const endRow = startRow + pageSize - 1;
  
    return rowIndex >= startRow && rowIndex <= endRow;
  }  

  initializeData() {
    // this.spinner.show();
    this.rowData = [];
    // this.spinner.show();

    this.namcValue = localStorage.getItem('namcvalue');

    if (localStorage.getItem('workdayId')) {
      this.user = localStorage.getItem('workdayId');
    }
    if (localStorage.getItem('UserRoles')) {
      this.userRole = localStorage.getItem('UserRoles');
    }
    if (localStorage.getItem('namcName')) {
      this.namcName = localStorage.getItem('namcName');
    }

    this.loadDrop();
    this.onResetDropDown();


    this.lookupService.getEasternDate().subscribe({
      error: (error) => this.errorCallback(error,'getEasternDate'),
      next: (res) => {
        this.easternDate = res.body.data;
      },
    });
  }
  checkIfAnySelected() {

    if (
      this.selectedDock?.length != 0
    ) {
      return true;
    }
    return false;
  }

  resetGrid() {
    if (this.osPartsGrid) {
      resetSortingAndFilters(this.osPartsGrid);

      return;
    }
  }

  onSearch(offset,removeMessage) {
    if (this.osPartsGrid) {
      this.headerCheckboxChecked = false;
      this.osPartsGrid.gridOptions.api.refreshHeader();

      this.resetGrid();
    }

    // this.removeMessage();
    if (removeMessage) {
      this.removeMessage();
    }

    if (offset === 0) {
      this.setPageSizeToAll(this.defaultPageSize);
      this.rowData = [];
      this.osPartsGrid.gridOptions.api.setRowData(this.rowData);

      // const { valid, error } = validateVanningDates({
      //   vanningFrom: this.effectiveFrom,
      //   vanningTo: this.effectiveTo,
      // });

      // if (!valid) {
      //   this.warningMessage = error;
      //   window.scroll(0, 0);

      //   this.spinner.hide();

      //   return;
      // }

      this.offset = 0;
      // this.spinner.show();
    }

    if (!this?.checkIfAnySelected()) {
      this.rowData = [];
      this.warningMessage = warningMessage.selectDock;

      window.scroll(0, 0);
      this.spinner.hide();
      return false;
    }
    this.showDefaultButton = true;  
    let kanban;
    // let selectedPartsControl;
    let selectedDock;
    let selectedGetAddress;
    let selectedSpecialist;
    let selectedGetGroupName;

    // if (this.selectedKanban?.length > 0) {
    //   if (!this.selectedKanban.some((a) => a.kanban === 'ALL')) {
    //     kanban = [];
    //     this.selectedKanban.forEach((element) => {
    //       kanban.push(element.kanban);
    //     });
    //   }
    // }

    // if (this.selectedPartsControl.length > 0) {
    //   if (!this.selectedPartsControl.some((a) => a.pctl_cd === 'ALL')) {
    //     selectedPartsControl = [];
    //     this.selectedPartsControl.forEach((element) => {
    //       selectedPartsControl.push(element.pctl_cd);
    //     });
    //   }
    // }

    if (this.selectedDock?.length > 0) {
      if (!this.selectedDock.some((a) => a.dock === 'ALL')) {
        selectedDock = [];
        this.selectedDock.forEach((element) => {
          selectedDock.push(element.dock);
        });
      }
    }

    if (this.selectedGetAddress.length > 0) {
      if (!this.selectedGetAddress.some((a) => a.address === 'ALL')) {
        selectedGetAddress = [];
        this.selectedGetAddress.forEach((element) => {
          selectedGetAddress.push(element.address);
        });
      }
    }
    if (this.selectedGetGroupName.length > 0) {
      if (!this.selectedGetGroupName.some((a) => a.group_name === 'ALL')) {
        selectedGetGroupName = [];
        this.selectedGetGroupName.forEach((element) => {
          selectedGetGroupName.push(element.group_name);
        });
      }
    }


    // if (this.selectedSpecialist?.length > 0) {
    //   if (!this.selectedSpecialist.some((a) => a.employee === 'ALL')) {
    //     selectedSpecialist = [];
    //     this.selectedSpecialist.forEach((element) => {
    //       selectedSpecialist.push(element.employee);
    //     });
    //   }
    // }
    const apiDefaultLimit = 500;
    this.loading = true;

    const data = {
      offset: offset,
      limit: apiDefaultLimit,
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      kanban: this.selectedKanban?.kanban || '',
      // partsControl: this.selectedPartsControl.pctl_cd || '',
      partGroup:this.selectedGetGroupName.group_name || '',
      address:this.selectedGetAddress.address || '',
      dock: this.selectedDock?.dock,
      specialist: this.selectedSpecialist?.employee || '',
      eventType: '',
    };

    // Modify partGroup to match the format and set eventType
    if (data.partGroup === 'UvR MIN') {
      data.partGroup = 'UVR_MIN'; // Change to 'UVR_MIN'
      data.eventType = 'Usage v Receipt - minimum reached';
    } else if (data.partGroup === 'UvR MAX') {
      data.partGroup = 'UVR_MAX'; // Change to 'UVR_MAX'
      data.eventType = 'Usage v Receipt - maximum reached';
    } else if (data.partGroup === 'UvR MIN MAX') {
      data.partGroup = 'UVR_MIN_MAX'; // Change to 'UVR_MIN_MAX'
      data.eventType = 'Usage v Receipt - maximum and minimum reached';
    }else if (data.partGroup === 'TO BE COUNTED') {
      data.partGroup = 'TO_BE_COUNTED'; // Change to 'UVR_MIN_MAX'
      // data.eventType = 'Usage v Receipt - maximum and minimum reached';
    }

    this.spinner.show();
    this.partsCountService.getPartsCountData(data)?.subscribe({
      error: (error) => this.errorCallback(error,'getPartsCountData'),
      next: (res) => {
        // console.log('--------------------', res);
        // console.log('--------------------1', res.body.parentData);
        const parentData = res.body.body.data;
        if (!offset && res.body.body.rowCount < 1) {
          this.spinner.hide();
          this.warningMessage = warningMessage.noDataAvailble;

          return;
        }
    // Check if parentData is not empty and contains ParentData
        if (parentData && parentData.length > 0 && (parentData[0]?.ParentData || parentData[0])) {
          const dataToPush = parentData[0]?.ParentData || parentData;
          // Sort each parent's children by container_renban DESC
          dataToPush.forEach(parent => {
            if (Array.isArray(parent.children)) {
              parent.children.sort((a, b) => b.container_renban.localeCompare(a.container_renban));
            }
          });
          this.rowData?.push(...dataToPush);

          this.osPartsGrid.gridOptions?.api?.setRowData(this.rowData);
          this.dataCount = Math.round(parseFloat(res.body?.body.rowCount)) ?? parseInt(parentData[0]?.rowCount);
          const records = this.dataCount - (this.offset + 1) * apiDefaultLimit;
          // console.log('Remaining Records:', records);
          if (records > 0 || records <= 500) {
            this.offset++;
            this.onSearch(this.offset * apiDefaultLimit,false);
            this.spinner.show();
            return;
          } else {
            // this.rowData?.push(...dataToPush);
            this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
            this.spinner.hide();
            this.loading = false;
          }
        } 
        this.spinner.hide();
        this.setPageSizeToAll();        
      },
    });
    this.isEditMode = false;
    // return true;
  }

  defaultLoad(){
    const data1 = {
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      dock: this.selectedDock?.dock,
    };
    // this.spinner.show();
    this.defaultArr = [];
    this.containerList = [];
    this.moduleList = [];
    this.selectedContainer = {};
    this.selectedModule = {};
    this.spinner.show();
    this.partsCountService.getDefault(data1).subscribe(
      {
        next: (res) => {
          if (res?.error) {
            this.warningMessage = 'Try after some time! Error in Dedault dropdown.';
            this.spinner.hide();
          } else {
            if (res.body === "No Content"){
              //NCR
            }else{
              this.defaultArr = res.body;
              if (this.defaultArr.length > 0){
                this.containerList = [...new Set(this.defaultArr.map(item => item.container_renban))]
                .sort((a, b) => String(a).localeCompare(String(b)))
                .map(container_renban => ({ container_renban }));            
              }
            }
           this.spinner.hide();		
          }
        },
        error: (error) => this.errorCallback(error),
      }
    );
  }
  onDefault() {          
    this.removeMessage();

    if (!this.checkIfAnySelectedDefault()){
      window.scroll(0, 0);
      return;
    }

    let defaultContainer = this.selectedContainer.container_renban;
    let defaultModule = this.selectedModule.module_number;
    const planStockingDate = this.planned_stocking_date;

    if (!planStockingDate) {
      this.warningMessage = `There's no planStockingDate found for renban/module '${defaultContainer}/${defaultModule}'`;
      window.scroll(0, 0);
      return;
    }

    this.spinner.show();
    const newPlanStockingDate = Number(planStockingDate.replaceAll('/', ''));
    const currentDateInt = Number(this.getCurrentDate(false));

    let inFuture = false;

    if (newPlanStockingDate > currentDateInt) {
      inFuture = true;
    }


    let error = false;
    let warning = false;
    let existingPlanStockingDateInt = 0;      

    for (const partsCountForm of this.rowData) {

      const existingPlanStockingDate = partsCountForm.old_line_off_dt;

      if (!existingPlanStockingDate) {
        existingPlanStockingDateInt = 0;
      } else {
        existingPlanStockingDateInt = Number(existingPlanStockingDate.replaceAll('/', ''));
      }

      if (existingPlanStockingDateInt !== 0 && newPlanStockingDate < existingPlanStockingDateInt) {
        // Error
        error = true;
        partsCountForm.errorType = "NOK";
        partsCountForm.errorDesc = `The new countDate (${planStockingDate}) is older than the existing one (${existingPlanStockingDate})!`;
      } else if (existingPlanStockingDateInt !== 0 && newPlanStockingDate === existingPlanStockingDateInt) {
        // Warning
        warning = true;
        partsCountForm.errorType = "W1";
          partsCountForm.errorDesc = `The new countDate (${planStockingDate}) equals the existing one!`;
      } else if (newPlanStockingDate > existingPlanStockingDateInt) {
        if (inFuture) {
          // Warning
          warning = true;
          partsCountForm.errorType = "W2";
          partsCountForm.errorDesc = `The new countDate (${planStockingDate}) is in the future!`;  
        } else {
          partsCountForm.errorType = "OK";
        }
      }

      // Only set the defaults if filled in.
      if (defaultContainer) {
        partsCountForm.renban_number = defaultContainer;
        partsCountForm.isRenbanUpdated = true;
      }
      if (defaultModule) {
        partsCountForm.module_code = defaultModule;
        partsCountForm.isModuleUpdated = true;
      }
      partsCountForm.line_off_dt = planStockingDate;
    }

    // console.log('after default ', this.rowData);
    this.headerCheckChanged({ checked: true });
    this.toggleHeaderCheckbox(true);
    this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
    this.isEditMode = false;
    this.onEditMode();
    const formatted = this.rowData
      .filter(item => ["W1", "W2", "NOK"].includes(item.errorType))
      .map(item => {
        const id = item.kanban || item.item_id;
        return `Kanban - ${id}, ${item.errorDesc}`;
      })
      .join('\n');

    if (formatted) {
      this.warningMessage = formatted;
    }

    // const formatted = this.rowData
    //   .filter(item => ["W1", "W2", "NOK"].includes(item.errorType))
    //   .map(item => `Part No - ${item.item_id}, ${item.errorDesc}`)
    //   .join('\n');
    // if (formatted) {
    //   this.warningMessage = formatted;
    // }
    this.spinner.hide();
  }

  checkIfAnySelectedDefault() {
    const msgPrefix = 'Please select '
    let msgArr = [];
    //console.log('this.selectedDock', this.selectedDock);

    if (this.selectedContainer){
      if (Object.keys(this.selectedContainer).length === 0){
        msgArr.push('Next Renban');
      }
    }else{
      msgArr.push('Renban');
    }

    if (this.selectedModule){
      if (Object.keys(this.selectedModule).length === 0){
        msgArr.push('Module');
      }
    }else{
      msgArr.push('Module');
    }
      
    if (msgArr.length > 0){
      this.warningMessage = `${msgPrefix}${msgArr.join(', ')}.`;
      return false;
    }
     
    return true;
  }

  loadDrop() {
    this.spinner.show();

    const data = {
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      userid: this.userName,
    };
    const data1 = {
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      userid: this.userName,
      dock:this.selectedDock?.dock,
    };
    //let incomingDockValue = null;
    // this.route.queryParams.subscribe(params =>{
    //   const dockParam = params['selectedDock'];
    //   if(dockParam){
    //     try {
    //       const parsed = JSON.parse(dockParam);
    //       incomingDockValue = parsed[0];
    //     }catch(e){
    //       console.error('error parsing selectedDockfrom query params', e)
    //     }
    //   }
    //   this.defaultLoad();
    // });
    // console.log(data1,'data1')
    const lookupSubscriptions = [
      // this.lookupService.getKanban(),
      // this.partsCountService.getPartsControl(data),
      // this.lookupService.getPartNumber(),
      // this.lookupService.getSpecialist(),
      // this.lookupService.getDock(),
      this.partsCountService.getAddress(data),
      this.partsCountService.getGroupName(data1),
      // this.OspService.getpolicyName(data),
      this.lookupService.getqpcforpart(),
    ];
    forkJoin(lookupSubscriptions).subscribe({
      next: (res) => {
        //if kanbanList, add ALL option
        this.kanbanList = [];
        this.partsControlList = [];
        this.partNoListAdd = [];
        this.dockList = [];
        this.dockListTo =[];
        this.dockListForpopup = [];
        this.specialistList = [];
        this.dockListCopy = [];
        this.dockListToCopy = []
        // this.policyNameList = [];
        this.getAddressList = [];
        this.getGroupName = [];
        this.getGroupNameCopy = [];
        this.qpcforParts = [];
        // if (res[0].body.data) {
          // this.kanbanList.push(...res[0].body.data);
        // }

        // this.kanbanList.push(...res[0].body.data);
        // this.selectedKanban = [{ kanban: 'ALL' }];
        //if item id list, add ALL option
        // if (res[1].body) {
          // this.partsControlList.push(...res[1].body);
        // }

        // if (res[3].body.data) {
          // this.dockList.push({ dock: 'ALL' });
        // }
        // this.dockList.push(...res[2].body.data);
        // this.selectedDock = [{ dock: 'ALL' }];
        // if (res[2].body.data) {
          // this.specialistList.push(...res[1].body.data);
        // }
        // if (res[4].body) {
          if (!res[0].error) {
            if (res[0].body) {
              this.getAddressList.push(...res[0].body);
            } 
          } else {
            this.warningMessage = 'Try after some time! Error in ADDRESS';
          }
        // }
        // console.log(res[0].body,'getaddressaaaaaaaaaaa')

        if (!res[1].error) {
          if (res[1].body) {
            // The additional dropdown values that you want to show first
            const additionalValues = [
              { dock:'D', group_name: 'TO BE COUNTED' },
              { dock:'D',group_name: 'UvR MIN' },
              { dock:'D',group_name: 'UvR MAX' },
              { dock:'D', group_name: 'UvR MIN MAX' }
            ];
        
            // Unshift the additional values to the beginning of the array
            this.getGroupName.unshift(...additionalValues);
            // Then, push the response values (res[5].body) after the additional values
            this.getGroupName.push(...res[1].body);
            this.getGroupNameCopy = this.getGroupName;
            // this.getGroupNameCopy = [...this.getGroupName];
            this.getGroupName = this.getGroupName.filter(
              (value, index, self) => index === self.findIndex((t) => t.group_name === value.group_name)
            );

          }
        } else {
          this.warningMessage = 'Try after some time! Error in GROUP';
        }
        // if (!res[5].error) {
        //   if (res[5].body) {
        //     this.rowdata = res[5].body.data;
        //     let myList = [];
        //     this.rowdata.forEach((element) => {
        //       let alradyExist = myList.findIndex((x) => x.dock == element.dock);
        //       if (alradyExist === -1) {
        //         myList.push(element);
        //       }
        //     });
        //     this.dockList = myList;
        //   }
        // } else {
        //   this.warningMessage = 'Try after some time! Error in get dock, Part, Kanban, Specialist';
        // }
        if (!res[2].error) {
          if (res[2].body) {
            this.rowdata = res[2].body.data;

            // Get unique docks
            const docks = new Set();
            this.dockList = [];
            this.dockListTo = [];

            this.rowdata.forEach((item) => {
              if (!docks.has(item.dock)) {
                docks.add(item.dock);
                this.dockList.push({ dock: item.dock });
                this.dockList = this.dockList.sort((a, b) => a.dock.localeCompare(b.dock));

                // this.kanbanList.push({kanban:item.kanban});
                // this.specialistList.push({employee:item.employee});
              }
            });
            this.dockListCopy = this.dockList;
            const dockSet = new Set();
            this.dockListTo = this.rowdata;

            // .filter(x => {
            //   if (!dockSet.has(x.dock)) {
            //     dockSet.add(x.dock);
            //     return true;
            //   }
            //   return false;
            // })
            // .sort((a, b) => Number(a.dock) - Number(b.dock));

            const kanbanSet = new Set();
            this.kanbanList = this.rowdata
              .filter(x => {
                if (!kanbanSet.has(x.kanban)) {
                  kanbanSet.add(x.kanban);
                  return true;
                }
                return false;
              })
              .sort((a, b) => Number(a.kanban) - Number(b.kanban));

            // this.kanbanList.filter(x=>{x.dock = this.selectedDock.dock});
            // console.log(this.kanbanList, 'kanaban')
            // Step 4: Deduplicate and sort Specialist list
            const empSet = new Set();
            this.specialistList = this.rowdata
              .filter(x => {
                if (!empSet.has(x.employee)) {
                  empSet.add(x.employee);
                  return true;
                }
                return false;
              })
              .sort((a, b) => Number(a.employee) - Number(b.employee));
            // this.specialistList.filter(x=>{x.dock = this.selectedDock.dock});
            // if(incomingDockValue){
            //   const matchedDock = this.dockList.find(d => d.dock === incomingDockValue);
            //   if(matchedDock){
            //     this.selectedDock= matchedDock;
            //   }
            // }else{
            //   const savedDock = localStorage.getItem('selectedDock');
            //   const matchingDock = this.dockList.find(d => d.dock === savedDock);
            //   if(matchingDock){
            //     this.selectedDock= matchingDock;
            //   }
            // }

          }
        } else {
          this.warningMessage = 'Try after some time!';
        }
        
        // this.partNoListAdd.push(...res[1].body)
        if(this.assignDefaultDock()){
          this.onDockChange();
          this.getGetGroupNameChange();
        }
        this.dockListForpopup.push(...res[2].body.data)
       
        this.spinner.hide();
      },
      error: (error) => this.errorCallback(error),
    });
    
  //  this.loadData(data, data1);
  }

  // async loadData(data, data1) {
  //   try {
  //     const addressRes = await this.partsCountService.getAddress(data).toPromise();
  //     this.getAddressList = addressRes.body || [];
  
  //     // const groupRes = await this.partsCountService.getGroupName(data1).toPromise();
  //     // const additionalValues = [
  //     //   { dock: 'D', group_name: 'TO BE COUNTED' },
  //     //   { dock: 'D', group_name: 'UvR MIN' },
  //     //   { dock: 'D', group_name: 'UvR MAX' },
  //     //   { dock: 'D', group_name: 'UvR MIN MAX' }
  //     // ];
  //     // this.getGroupName = [...additionalValues, ...groupRes.body];
  //     // this.getGroupNameCopy = this.getGroupName.filter(
  //     //   (value, index, self) => index === self.findIndex((t) => t.group_name === value.group_name)
  //     // );
  
  //     // const qpcRes = await this.lookupService.getqpcforpart().toPromise();
  //     // this.qpcforParts = qpcRes.body || [];
  //   } catch (err) {
  //     this.warningMessage = 'Try after some time!';
  //   } finally {
  //     this.spinner.hide();
  //   }
  // }
  

  onKeyPress(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    const isNumber = /^[0-9]$/.test(event.key);

    // Allow number keys, allowed keys, and prevent default for others
    if (!isNumber && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  // errorCallback = (error) => {
  //   logErrors(error);
  //   this.spinner.hide();

  //   this.warningMessage = 'Something went wrong! Please contact support team.';
  //   this.rowData = [];
  //   this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
  // };
  errorCallback = (error,apiName = '') => {
    logErrors(error);
    this.spinner.hide();

    let detailedMessage = 'Something went wrong! Please contact support team.';
    let backendMessage = '';
    if(error?.error?.message){
      backendMessage = error.error.message;
    } else if(error?.message){
      backendMessage = error.message;
    }
    if(backendMessage){
      detailedMessage += `| ${backendMessage}`;
    } else if(apiName){
      detailedMessage += `| Try after some time! Error in ${apiName}`;
    }
    this.warningMessage = detailedMessage;
    this.rowData = [];
    this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
  };
  onResetDropDown() {
    this.removeMessage();
    this.selectedKanban = [];
    // this.selectedPartsControl = [];
    this.selectedDock = [];
    this.dockList = this.dockListCopy ;
    this.dockListTo = [];
    this.dockListTo = this.rowdata;
    this.selectedSpecialist = [];
    this.selectedGetAddress = [];
    // this.selectedPartsControl  = [];
    this.selectedGetGroupName = [];
    this.isEditMode = false;
    this.editEnabled = false;
    
    this.getGroupName = [];
    this.getGroupName = this.getGroupNameCopy;
    this.getGroupName = this.getGroupName.filter(
      (value, index, self) => index === self.findIndex((t) => t.group_name === value.group_name)
    );
    this.effectiveFrom = '';
    this.effectiveTo = '';
    ///testing 
    this.kanbanList=[];
    this.specialistList=[];
    this.containerList = [];
    this.moduleList = [];
    this.selectedContainer = {};
    this.selectedModule = {};
    this.showDefaultButton = false;

    const kanbanSet = new Set();
    this.kanbanList = this.rowdata
      .filter(x => {
        if (!kanbanSet.has(x.kanban)) {
          kanbanSet.add(x.kanban);
          return true;
        }
        return false;
      })
      .sort((a, b) => Number(a.kanban) - Number(b.kanban));

    // this.kanbanList.filter(x=>{x.dock = this.selectedDock.dock});
    // console.log(this.kanbanList, 'kanaban')
    // Step 4: Deduplicate and sort Specialist list
    const empSet = new Set();
    this.specialistList = this.rowdata
      .filter(x => {
        if (!empSet.has(x.employee)) {
          empSet.add(x.employee);
          return true;
        }
        return false;
      })
      .sort((a, b) => Number(a.employee) - Number(b.employee));
    // this.specialistList.filter(x=>{x.dock = this.selectedDock.dock});



    if (this.osPartsGrid) {
      this.headerCheckboxChecked = false;
      this.osPartsGrid.gridOptions.api.refreshHeader();
      this.resetGrid();
    }

    this.setPageSizeToAll(this.defaultPageSize);

    this.rowData = [];
    this.disableKanban = false;
    this.disablePartscontrol = false;
    this.offset = 0;
  }

  toggleHeaderCheckbox(checked) {
    if (!checked) {
      this.headerCheckboxChecked = false;
      this.osPartsGrid.gridOptions.api.refreshHeader();
      return;
    }

    const rowCount = this.osPartsGrid.gridOptions.rowData.length;
    const selectedRowCount = this.osPartsGrid.gridOptions.rowData.filter(
      (x) => x.rowCheckBox === true
    ).length;

    if (rowCount === selectedRowCount) {
      this.headerCheckboxChecked = true;
      this.osPartsGrid.gridOptions.api.refreshHeader();
    }
  }
  userCheckChanged(checked, rowIndex) {
    this.spinner.show();
    const rowNode =
      this.osPartsGrid?.gridOptions?.api?.getDisplayedRowAtIndex(rowIndex);
    if (checked === true) {
      rowNode.setSelected(true);
      if (this.isEditMode) {
        rowNode.data.checkedEditMode = true;
      }
      rowNode.data.rowCheckBox = true;
    } else {
      rowNode.setSelected(false);
      rowNode.data.checkedEditMode = false;
      rowNode.data.rowCheckBox = false;
    }

    this.gridOptions.getRowStyle = function (params) {
      if (params.node.rowIndex === rowIndex) {
        const color = checked ? '#E4ECF0' : 'white';
        return { background: color };
      }
      return { background: 'white' };
    };

    rowNode.setData(rowNode.data);
    this.toggleHeaderCheckbox(checked);
    this.spinner.hide();
  }
  headerCheckChanged(event) {
    this.headerCheckboxChecked = event.checked;
    const headerChecked = event.checked;
    const isEditable = this.isEditMode;
    this.osPartsGrid.gridOptions.api.forEachNode(function (rowNode, index) {
      if (headerChecked) {
        if (isEditable) {
          rowNode.data.checkedEditMode = true;
        }
        rowNode.data.rowCheckBox = true;
      } else {
        rowNode.data.rowCheckBox = false;
        rowNode.data.checkedEditMode = false;
      }
      rowNode.setData(rowNode.data);
    });
  }

  // onKanbanChange(): void {
  //   if (this.selectedKanban.length >= 1) {
  //     this.selectedKanban = {
  //       kanban: [this.selectedKanban.kanban],
  //     };
      
  //   }
    
  // }
  // onPartControlChange(event): void {
  //   if (this.selectedPartsControl.length >= 1) {
  //     this.selectedPartsControl = {
  //       pctl_cd: [this.selectedPartsControl.pctl_cd],
  //     };
      
  //   }

  // }

  kanbanselect = false;
  dockChange(): void {
    
    this.selectedGetGroupName = [];
    this.getGroupName=[]
    this.getGroupName = this.getGroupNameCopy; // Restore the original list for filtering

    // Ensure selectedDock has a valid dock value
    if (this.selectedDock && this.selectedDock.dock) {
      // console.log("Selected Dock:", this.selectedDock.dock);

      // Filter the original kanban list based on the selected dock
      const filteredList = this.getGroupName.filter(item => item?.dock?.trim() === this.selectedDock.dock.trim() || item.dock ==='D' );
      // console.log(filteredList, 'filteredList')
      if (filteredList.length > 0) {
        this.getGroupName = filteredList; // Update kanbanList with sorted results
        this.getGroupName = filteredList.filter(
          (value, index, self) => index === self.findIndex((t) => t.group_name === value.group_name)
        );
      } else {
        // console.warn("No matches found for the selected dock.");
        this.getGroupName = []; // Clear the list if no matches are found
      }
    } else {
      // console.error("Invalid dock selection. Please select a valid dock.");
      this.getGroupName = []; // Clear the list if no valid dock is selected
    }
  }
  // Method: When dock is changed
  
  
  // onDockChange() {
  //   if (!this.selectedDock || !this.selectedDock.dock) {
  //     console.warn('Dock not selected properly.');
  //     return;
  //   }
  
  //   const selectedDock = this.selectedDock.dock.toLowerCase();
  
  //   // Step 1: Filter all entries for selected dock
  //   let filteredData = this.rowdata.filter(
  //     x => x.dock.toLowerCase() === selectedDock
  //   );
  
  //   // Step 2: Remove duplicate kanbans
  //   const kanbanSet = new Set();
  //   this.kanbanList = filteredData
  //     .filter(x => {
  //       if (!kanbanSet.has(x.kanban)) {
  //         kanbanSet.add(x.kanban);
  //         return true;
  //       }
  //       return false;
  //     })
  //     .sort((a, b) => Number(a.kanban) - Number(b.kanban)); 
  
  //   // Step 3: Remove duplicate employees
  //   const empSet = new Set();
  //   this.specialistList = filteredData
  //     .filter(x => {
  //       if (!empSet.has(x.employee)) {
  //         empSet.add(x.employee);
  //         return true;
  //       }
  //       return false;
  //     })
  //     .sort((a, b) => Number(a.employee) - Number(b.employee)); 
  
  //   // Step 4: Reset selected values
  //   this.selectedKanban = null;
  //   this.selectedSpecialist = null;
  //   this.kanbanselect = true;
  
  //   // Logs for debugging
  //   console.log('✔ Kanban List:', this.kanbanList);
  //   console.log('✔ Specialist List:', this.specialistList);
  // }
  onDockChange(): void {
    if (!this.selectedDock || !this.selectedDock.dock) {
      // console.error("Invalid dock selection. Please select a valid dock.");
      this.getGroupName = [];
      this.kanbanList = [];
      this.specialistList = [];
      return;
    }
     // Update queryParams
    // this.router.navigate([], {
    //   queryParams: {
    //     selectedDock: JSON.stringify([this.selectedDock.dock])
    //   },
    //   queryParamsHandling: 'merge' // keeps other existing params
    // });
    const selectedDock = this.selectedDock?.dock?.trim().toLowerCase();
    // console.log(this.selectedKanban,'selectedKanban...............')
    // Restore the original group list
    this.getGroupName = this.getGroupNameCopy;
    this.selectedGetGroupName = [];

    // Step 1: Filter all entries from rowdata for selected dock
    let filteredData = this.rowdata.filter(
      x => x.dock?.trim().toLowerCase() === selectedDock
    );

    // Step 2: Filter getGroupNameCopy based on dock or 'D'
    const groupFilteredList = this.getGroupNameCopy.filter(
      item => item?.dock?.trim().toLowerCase() === selectedDock || item.dock === 'D'
    );

    // Deduplicate group names
    this.getGroupName = groupFilteredList.filter(
      (value, index, self) =>
        index === self.findIndex((t) => t.group_name === value.group_name)
    );

    // console.log("✔ Group Name List:", this.getGroupName);

    // Step 3: Deduplicate and sort Kanban list
    // console.log(this.selectedKanban?.length,'length')
    // console.log(this.selectedKanban,'withoutlength')
    // if(this.selectedKanban.kanban === null){
    if (this.selectedKanban?.length === 0) {
      // console.log(this.selectedKanban?.length, 'length')

      const kanbanSet = new Set();
      this.kanbanList = filteredData
        .filter(x => {
          if (!kanbanSet.has(x.kanban)) {
            kanbanSet.add(x.kanban);
            return true;
          }
          return false;
        })
        .sort((a, b) => Number(a.kanban) - Number(b.kanban));

      this.kanbanList.filter(x => { x.dock = this.selectedDock.dock });
      // console.log(this.kanbanList, 'kanaban')
    }
    // Step 4: Deduplicate and sort Specialist list
    if (this.selectedSpecialist.length === 0) {
      const empSet = new Set();
      this.specialistList = filteredData
        .filter(x => {
          if (!empSet.has(x.employee)) {
            empSet.add(x.employee);
            return true;
          }
          return false;
        })
        .sort((a, b) => Number(a.employee) - Number(b.employee));
      this.specialistList.filter(x => { x.dock = this.selectedDock.dock });
      // console.log(this.specialistList, 'specialistList')
    }

    // Step 5: Reset selected values
    // this.selectedKanban = null;
    // this.selectedSpecialist = null;
    // this.kanbanselect = true;

    // Debug logs
    // console.log("✔ Kanban List:", this.kanbanList);
    // console.log("✔ Specialist List:", this.specialistList);
    // console.log("✔ Selected Get Group Name:", this.selectedGetGroupName);
    this.defaultLoad();
    this.getGetGroupNameChange();
    this.defaultService.setDockCode(JSON.stringify([{dock : this.selectedDock.dock}]));
  }

  assignDefaultDock(){
    try {
      if (this.dockList?.length > 0){
        const defaultdockArray : any[] = JSON.parse(this.defaultService.getCurrentDockCode());
        if (Array.isArray(defaultdockArray)){
          const validDocks = new Set(defaultdockArray.map(item => item.dock));
          this.selectedDock = this.dockList.find(item => validDocks.has(item.dock));
          if (this.selectedDock){
            return true;
          }
        }
      }
      return false;
    } catch (error) {
      console.log('Error in assigning default dock',error);
      return false;
    }
  }
  
  // Method: When Kanban is selected
  onKanbanChange() {
    // console.log(this.selectedDock, this.selectedSpecialist, 'dock & selectedSpecialist');
    // this.dockList
    if (this.selectedKanban) {
      // this.selectedSpecialist = this.selectedKanban.employee;
      // console.log('Kanban selected:', this.selectedKanban.kanban);
      // console.log(this.dockListTo, 'dockList before filtering');
      // console.log(this.selectedSpecialist, 'selectedSpecialist');
      
      if (!this.selectedDock || this.selectedDock.length === 0) {
        this.dockList = [];
        this.dockList = this.dockListCopy;
        this.dockListTo =[];
        this.dockListTo = this.rowdata;
    
        this.dockListTo = this.dockListTo.filter(
          x => x.kanban === this.selectedKanban.kanban
        );
        this.dockList = this.dockListTo;
        this.dockList = this.dockList.filter(
          (value, index, self) => index === self.findIndex((t) => t.dock === value.dock)
        );
  
      
  

      }
      // console.log("this.selectedSpecialist",this.selectedSpecialist)
  
      if (this.selectedSpecialist.length === 0 ) {
        this.specialistList.filter(x => x.kanban === this.selectedKanban.kanban);
      }
  
      // console.log(this.dockListTo, 'dockList after filtering');
      // console.log(this.specialistList, 'specialistList after filtering');
    }
  }
  

  // Method: When Specialist is selected
  onSpecialistChange() {
    // console.log(this.selectedDock , this.selectedKanban,'dock & selectedKanban')
    // console.log(this.selectedDock, this.selectedSpecialist, 'dock & selectedSpecialist');
    // this.dockList
    if (this.selectedSpecialist && this.selectedSpecialist.employee) {
      // console.log(this.dockListTo, 'selectedSpecialist');
      
      if (!this.selectedDock || this.selectedDock.length === 0) {
        this.dockList = [];
        this.dockList = this.dockListCopy;
        this.dockListTo =[];
        this.dockListTo = this.rowdata;
    
        const empId = this.selectedSpecialist.employee;

        this.dockListTo = this.dockListTo.filter(
          x => x.employee === empId
        );
        this.dockList = this.dockListTo;
        this.dockList = this.dockList.filter(
          (value, index, self) => index === self.findIndex((t) => t.dock === value.dock)
        );
  
      }
  
      if (!this.selectedKanban || this.selectedKanban.length === 0) {
              const empId = this.selectedSpecialist.employee;

      this.kanbanList = this.rowdata.filter(x => x.employee === empId);
      // console.log('Filtered by Specialist:', this.kanbanList);
      this.kanbanList = this.kanbanList.filter(
        (value, index, self) => index === self.findIndex((t) => t.kanban === value.kanban)
      ) .sort((a, b) => Number(a.kanban) - Number(b.kanban))
      }
  
      // console.log(this.dockListTo, 'dockList after filtering');
      // console.log(this.specialistList, 'specialistList after filtering');
    }
  }

  getAddressChange(): void {
    if (this.selectedGetAddress.length >= 1) {
      this.selectedGetAddress = {
        address: [this.selectedGetAddress.address],
      };
    }
  }
  getGetGroupNameChange(): void {
    if (this.selectedGetGroupName.length >= 1) {
      this.selectedGetGroupName = {
        group_name: [this.selectedGetGroupName.group_name],
      };
    }
  }
  specialistChange(): void {
    if (this.selectedSpecialist.length >= 1) {
      this.selectedSpecialist = {
        EMPLOYEE: [this.selectedSpecialist.employee],
      };
    }
  }

  onContainerChange(): void {
    this.moduleList = [];
    const filteredModule = [...new Set(
      this.defaultArr
        .filter(item => item.container_renban === this.selectedContainer.container_renban) // Step 1: Filter by dock
        .map(item => item.module_number) // Step 2: Extract container_renban values
    )]
      .sort((a, b) => String(a).localeCompare(String(b))) // Step 3: Sort in ascending order
      .map(module_number => ({ module_number })); // Step 4: Convert to object format

    this.moduleList.push(...filteredModule);
    this.selectedModule = {};
  }

  onModuleChange() : void {
    this.planned_stocking_date = this.defaultArr.find(f => f.container_renban === this.selectedContainer.container_renban &&
       f.module_number === this.selectedModule.module_number
    )?.planned_stocking_date;
    console.log('planned_stocking_date',this.planned_stocking_date);
  }

  removeMessage() {
    this.warningMessage = '';
    this.successMessage = '';
    this.warningMessageUpload = '';
  }

  // updateURLAndNavigate() {
  //   const key: any = 'keyParam';
  //   const value: string = new Date().getTime() + '';
  //   localStorage.setItem(value, JSON.stringify(this.onSearch(0,true)));
  //   const url = new URL(window.location.href);
  //   url.searchParams.append(key, value);
  //   history.pushState(null, '', url.toString());
  // }
  // editGroups() {
  //   // this.updateURLAndNavigate();
  //   this.router.navigate(['parts-group']);
  // }
  editGroups() {
    let selectedDocks = [];
  
    if (Array.isArray(this.selectedDock)) {
      selectedDocks = this.selectedDock.map(d => d.dock);
    } else if (this.selectedDock && typeof this.selectedDock === 'object') {
      selectedDocks = [this.selectedDock.dock];
    }
  
    this.router.navigate(['parts-group'], {
      // queryParams: {
      //   selectedDock: JSON.stringify(selectedDocks),
      // }
    });
  }
  //delete Button Dialog
  deleteButton(field: any): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = this.modalComponent;
    dialogConfig.width = '460px';
    dialogConfig.height = '200px';
    dialogConfig.data = {
      mode: 'Parts',
    };
    const data1 = {
      offset: 0,
      limit: 1200,
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      userid: this.userName,
      dock : this.selectedDock.dock,
      part_no : field?.part_no,
      id : field?.id,
    };
    const dialogRef = this.dialog.open(DeleteBreaksComponent, dialogConfig)
    dialogRef.afterClosed().subscribe((res) => {
      if (res === 'cancel') {
        return;
      } else if (res === 'save') {
        this.partsCountService.deletePartsCount(data1).subscribe({
          error: (error) => this.errorCallback(error,'deletePartsCount'),
          next: (data) => {
            if (data.body.table1DeletedCount >= 1 || data.body.table2DeletedCount >= 1) {
              // this.onSearch(0,true);
              // console.log('before Row Data:', this.rowData);
              // console.log('Field ID:', field.id);
              this.rowData.forEach((row, index) => {
                if (row.children && Array.isArray(row.children)) {
                  row.children = row.children.filter(child => String(child.id) !== String(field.id));
                }
              });
              // console.log('after Row Data:', this.rowData);
              this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
              this.osPartsGrid.gridOptions.api.refreshCells();  
              this.successMessage = successMessage.deleteRecord;
              this.spinner.hide();
              window.scroll(0, 0);
            } else {
              this.warningMessage = `${warningMessage.apiLogicFail}  ${this.itContact}.`;
              this.rowData = [];
              this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
              this.spinner.hide();
            }
          },
        });
      }
    })
  }

  exportAsXLSX(): void {
    this.removeMessage();

    this.spinner.show();

    // eastern time api
    const easternCurrentDate = String(mm().tz('US/Michigan').format('YYYY-MM-DD_HH:mm:ss'));
    // console.log(easternCurrentDate);
    let data = [];

    if (this.headerCheckboxChecked) {
      this.osPartsGrid.gridOptions.api.forEachNodeAfterFilter((node) => {
        data.push(node.data);
      });
    } else {
      data = this.getModifiedRowData();
    }

    if (data.length < 1) {
      this.spinner.hide();
      this.warningMessage = warningMessage.noRowsSelected;

      window.scroll(0, 0);
    } else {
      setTimeout(async () => {
        if (this.rowData.length > 0) {
          const exportData: any = [];

          data.forEach((e) => {
            const obj = {
              kanban: e.kanban,
              item_id: e.item_id,
              part_description:e.part_description,
              count_by: e.tobecounted_date, 
              // man: e.manually_added, 
              address: e.address,
              order_lot:e.order_lot || e.lotsize,
              // box_type:e.box_type,
              apccapacity: e.apccapacity,
              count_boxes: e.count_boxes,
              container_renban: '',
              module_number: '',
              // supplier_code: e.supplier_code,
              dock: e.dock,
              // updated_userid: e.updated_userid,
              // updated_date_time: e.updated_date_time,
            };
            exportData.push(obj);
          });

          let headers = [
            'KANBAN',
            'PARTNO',
            'DESCRIPTION',
            'COUNT BY', //order_lot
            // 'MAN',
            'PC ADDRESS',
            'ORDERLOT',
            // 'BOX TYPE',
            'SAFETY',
            'COUNT BOXES',
            'CONTAINER',
            'MODULE',
            // 'SUPPLIER',
            'DOCK',
            // 'Comment',
            // 'USER',
            // 'UPDATED DT',
          ];

          const timestamp = easternCurrentDate
            .split('.')[0]
            .replace('T', '_')
            .split('')
            .filter((d) => d !== '-' && d !== ':')
            .join('');

          //this.excelService.exportAsExcelFile(exportData, 'Parts-count_' + timestamp, headers);
          this.excelService.exportExcelFileStyle1(exportData, 'Parts-count_' + timestamp + '.xlsx', headers);
          
        }
        this.spinner.hide();
      }, 1000);
    }
  }
  onEditMode() {
    this.removeMessage();
    let data = [];

    data = this.getModifiedRowData();
    if (data.length > 0) {
      this.isEditMode = !this.isEditMode;
      this.editEnabled = this.isEditMode;

      if (this.isEditMode) {
        this.osPartsGrid.gridOptions.api.forEachNode(function (rowNode, index) {
          rowNode.data.checkedEditMode = true;
          if (!rowNode.data.rowCheckBox) {
            rowNode.data.checkedEditMode = false;
          }
          rowNode.setData(rowNode.data);
        });
      } else {
        this.osPartsGrid.gridOptions.api.forEachNode(function (rowNode, index) {
          if (rowNode.data.rowCheckBox) {
            rowNode.data.checkedEditMode = false;
          }
          rowNode.setData(rowNode.data);
        });
      }
      setTimeout(() => {
        window.scroll(0, document.body.scrollHeight);
      }, 100);
    } else {
      this.isEditMode = false;
      this.editEnabled = false;
      this.warningMessage = warningMessage.selectRowsToEdit;
      window.scroll(0, 0);
    }
  }
  onSaveMode(field:any){
    // const checkedRows = this.getModifiedRowData();
    const updateData = [{
      address: field?.address ?? field?.flowrack_address,
      checked: '',
      comment: field?.comment ?? '',
      business_entity: this.namcValue,
      container: (field?.renban_number ?? field?.containerRenban?.value)?.replace(/^./, c => c.toUpperCase()),
      // apcCapacity: field?.apcCapacity ?? field?.apcValue.value,
      apcCapacity: (field.apcValue.value != null) ? (field?.apcCapacity ?? field?.apcValue.value)  : null,
      module: (field?.module_code ?? field?.moduleNumber?.value)?.replace(/^./, c => c.toUpperCase()),
      // module1: (field?.module_number ?? field?.moduleNumber?.value)?.replace(/^./, c => c.toUpperCase()),
      count: field?.count_number ?? field?.countNumber?.value,
      // count1: field?.count_number ?? field?.count_number?.value,
      countDate: field?.countdate, 
      dock: this.selectedDock.dock,
      errorDesc: '',
      errorType: '',
      group: '',
      id: field?.id,
      kanbanNo: '',
      orderlot: field?.count_number ?? field?.countNumber?.value,
      partDescription: field?.part_description,
      partNo: field?.part_no,
      plant: '',
      supplier: field?.supplier_code ?? '',
      userId: this.userName,}]
    var data1 = {
      business_entity: this.namcValue,
      userid: this.userName,
      workid: this.user,
      user_role: this.userRole,
      filter: {
        "address": this.selectedGetAddress.address || '',
        "business_entity": this.namcValue,
        "dock": this.selectedDock.dock,
      },
      partscountList: updateData,
    };
    console.log('Submitting:', field);
    console.log('Payload:', data1);
    console.log('field.apc_value?.value:', field.apcValue?.value);
    console.log('field.apccapacity:', field.apccapacity);
    // console.log(data1,'data1')
    this.spinner.show();
    this.partsCountService.editsPartsCount(data1).subscribe({
      error: (error) => this.errorCallback(error,'editsPartsCount'),
      next: (response) => {
        // console.log('response.body.data', response);
        const { error, message } = response.body;
        // Hide the spinner initially
        this.spinner.hide();
        // Reset API call tracking
        // this.timesEditApiCalled = 0;
        // this.editApiStartPosition = 0;
        // this.editApiEndPosition = this.editApiDefaultLimit;
    
        if (error) {
          // Handle error scenario
          this.handleError(message);
          return;
        }
        // Handle success scenario
        this.handleSuccess(response);
      }
    });
  }
  getModifiedRowData(): any {
    // console.log(this.rowData,'rowdata')
    const modifiedRowData = this.rowData.filter((row) => row.rowCheckBox);
    return modifiedRowData;
  }
  openDialog1() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = this.modalComponent;
    dialogConfig.height = '250px';
    dialogConfig.width = '470px';
    dialogConfig.data = 'ospipe';
    const dialogRef = this.dialog.open(ConfirmCancelDailogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res) => {
      if (res === 'cancel') {
        this.columnDefs[7].cellStyle = function (params) {
          if ('modified' in params.data) {
            return { backgroundColor: '#E4ECF0' };
          } else {
            return { backgroundColor: 'white' };
          }
        };

        this.onSearch(0,true);
        this.editEnabled = false;
        this.isEditMode = false;
        this.osPartsGrid.gridOptions.api.refreshHeader();
      }
    });
  }
  cancelEdit(): void {
    this.removeMessage();
    this.openDialog1();
  }
  modifiedRowData = [];

  updatedRows = [];
  
  edit() {
    const checkedRows = this.getModifiedRowData();
  
    // Only keep rows where something was updated
    this.modifiedRowData = checkedRows.filter((row) =>
      row.isApcUpdated ||
      row.isCountUpdated ||
      row.isRenbanUpdated ||
      row.isModuleUpdated ||
      row.isSupplierNumberUpdated ||
      row.isCommentUpdated
    );
  
    // console.log('Edited Rows Only:', this.modifiedRowData);
  
    if (this.modifiedRowData.length === 0) {
      this.warningMessage = warningMessage.editToReview;
      window.scroll(0, 0);
      return;
    }
  
    const updatedData = this.modifiedRowData.map((e) => ({
      address: e.address ?? e.flowrack_address,
      apcCapacity: (e.apc_value?.value != null) ? e.apc_value.value : e.apccapacity,
      checked: '',
      comment: e.comment ?? '',
      business_entity: this.namcValue,
      container: (e.renban_number ?? e.containerRenban?.value)?.replace(/^./, c => c.toUpperCase()),
      count: e.orderLot ?? e.count_number?.value,
      countDate: e.count_by, // optional
      dock: e.dock,
      errorDesc: '',
      errorType: '',
      group: '',
      id: null,
      kanbanNo: e.kanban,
      module: (e.module_code ?? e.moduleNumber?.value)?.replace(/^./, c => c.toUpperCase()),
      orderlot: e.orderLot ?? '',
      partDescription: e.part_description,
      partNo: e.item_id,
      plant: '',
      supplier: e.supplier_code ?? '',
      userId: this.userName,
    }));
  
    // console.log(' Final Data to Send:', updatedData);
  
    this.spinner.show();
    this.editPartsCount(updatedData); // Only edited rows sent
  }
  editPartsCount(updatedData) {
    // console.log(updatedData,'updatedData')
    var data1 = {
      business_entity: this.namcValue,
      userid: this.userName,
      workid: this.user,
      user_role: this.userRole,
      filter: {
        "address": this.selectedGetAddress.address || '',
        "business_entity": this.namcValue,
        "dock": this.selectedDock.dock,
      },
      partscountList: updatedData,
    };
    // console.log(data1,'data1')
    this.spinner.show();
    this.partsCountService.editsPartsCount(data1).subscribe({
      error: (error) => this.errorCallback(error,'editsPartsCount'),
      next: (response) => {
        // console.log('response.body.data', response);
        const { error, message } = response.body;
        // Hide the spinner initially
        this.spinner.hide();
        // Reset API call tracking
        // this.timesEditApiCalled = 0;
        // this.editApiStartPosition = 0;
        // this.editApiEndPosition = this.editApiDefaultLimit;
    
        if (error) {
          // Handle error scenario
          this.handleError(message,false);
          return;
        }
        // Handle success scenario
        this.handleSuccess(response,true);
      }
    });
  };
  handleError(message: any, fromSaveMode: boolean = false) {
    if (typeof message === 'string') {
      // Replace Part No with Kanban if possible using rowData
      const splitMessages = message
        .split(/(?=Part No\s*-\s*)/)
        .map((msg) => {
          const match = msg.match(/Part No\s*-\s*(\S+)/);
          if (match) {
            const partNo = match[1];
            const row = this.rowData?.find(r => r.item_id === partNo);
            const kanban = row?.kanban;
            if (kanban) {
              return msg.replace(`Part No - ${partNo}`, `Kanban - ${kanban}`);
            }
          }
          return msg.trim();
        })
        .filter(m => m.length > 0); // Remove empty entries
  
      this.warningMessage = splitMessages.join('\n');
  
    } else if (Array.isArray(message)) {
      const formatted = message.map(item => {
        const row = this.rowData?.find(r => r.item_id === item.key);
        const kanban = row?.kanban;
        return kanban
          ? `Kanban - ${kanban}, ${item.message}`
          : `Part No - ${item.key}, ${item.message}`; // fallback
      }).join('\n');
  
      this.warningMessage = formatted;
    }
  
    // ✅ Only set edit mode flags if NOT fromSaveMode
    if (fromSaveMode) {
      this.editEnabled = true;
      this.isEditMode = true;
    }
  
    window.scroll(0, 0);
    this.setPageSizeToAll();
  }
  handleSuccess(response?: any, fromSaveMode: boolean = false) {
    let parts: string[] = [];
  
    if (
      response?.body?.partsCountArray &&
      response.body.partsCountArray.length > 0
    ) {
      parts = response.body.partsCountArray;
    } else if (
      response?.body?.partsCountUserArray &&
      response.body.partsCountUserArray.length > 0
    ) {
      parts = response.body.partsCountUserArray;
    }
  
    if (parts.length > 0) {
      // Create a Map from item_id to kanban using rowData
      const partToKanbanMap = new Map();
      this.rowData?.forEach(item => {
        if (item.item_id && item.kanban) {
          partToKanbanMap.set(item.item_id, item.kanban);
        }
      });
  
      // Map parts to kanban values
      const messages = parts.map(partNo => {
        const kanbanValue = partToKanbanMap.get(partNo);
        return kanbanValue
          ? `Kanban - ${kanbanValue}: Record(s) Updated Successfully.`
          : `Part No - ${partNo}: Record(s) Updated Successfully.`; // fallback if kanban not found
      });
  
      this.onSearch(0, true);
      this.successMessage = messages.join('\n');
    } else {
      this.successMessage = 'Record(s) Updated Successfully.';
    }
  
    // Only disable edit mode if NOT fromSaveMode
    if (!fromSaveMode) {
      this.editEnabled = false;
      this.isEditMode = false;
    }
  
    window.scroll(0, 0);
    this.setPageSizeToAll();
  }
  
  
  //upload 
  modifyRowDataForExport(data) {
    const modifiedDataForExport = [];

    for (const row of data) {
      // if (row.cont_code === 'ALL') {
      //   continue;
      // }

      // modifiedDataForExport.push({
      //   ...row,
      //   item_id: row.item_id ? row.item_id : row.hidden_item_id,
      //   kanban: row.kanban ? row.kanban : row.hidden_kanban,
      //   vanning_date: row.vanning_date ? row.vanning_date : row.hidden_vanning_date,
      //   order_lot: row.order_lot ? row.order_lot : row.hidden_order_lot,
      // });
    }

    return modifiedDataForExport;
  }

  getWrappedColumn1(partno, kanban, dock, countboxes, container_renban, module_number) {
    let v = "";

    const partNoSuccess = this.partsCountUserArray.find(e => e === partno);

    if (partNoSuccess){
      v = `Uploaded Successfully.`;
    }else{
      //UI Error
      if(!partno || !kanban || !dock || !countboxes || !container_renban || !module_number){
        const msg = "Please Provide ";
        const arr = [];
        if(!kanban){
          arr.push("Kanban");
        }
        if(!partno){
          arr.push("Part Number");
        }
        if(!countboxes){
          arr.push("Count Boxes");
        }
        if(!container_renban){
          arr.push("Container");
        }
        if(!module_number){
          arr.push("Module Number");
        }
        if (!dock){
          arr.push("Dock");
        }
        if (arr.length > 0){
          v = msg + arr.join(", ") + ".";
        }
      }      
      else{
        //Backend Error
        const error = this.errorDetails.find(
          e => e.partNo === partno && e.kanban === kanban && e.errorStatus === "NOK"
        );
    
        if (error){
          const partNo = this.partsCountUserArray.find(e => e === partno);
          if (!partNo){
            v = error.errorDescription;
          }
        }
      }
    
    }

    return { v, t: 's', s: { alignment: { wrapText: true } } };
  }

  getWrappedColumn(v) {
    return { v, t: 's', s: { alignment: { wrapText: true } } };
  }

  getExportData() {
    const data = [];

    const dataToExport = this.uploadError
      ? this.excelService.uploadedData
      : this.modifyRowDataForExport(this.exportData);

    // Normal export means user is normally exporting
    // There are no errors or it is not going to be uploaded
    // const normalExport = !this.validating && !this.uploadEnabled && !this.uploadError && !this.uploading;

    dataToExport.forEach((row) => {
      const fa_comment = row.fa_comment;
      // typeof row.comment === 'string' && row.comment?.length > 0
      //   ? row.comment
      //   : row.fa_comment ?? '';

      const newRow = {
        kanban: row.kanban,
        item_id: row.partno,
        part_description: row.description,
        tobecounted_date:row.countby,
        // manually_added:row.man,
        address:row.pcaddress,
        order_lot: row.orderlot,
        business_entity:row.boxtype, //BOX TYPE
        apccapacity: row.safety,
        EMPLOYEE:row.countboxes, //COUNT BOXES
        container_renban: row.container,
        module_number: row.module,
        supplier_code: row.supplier,
        dock: row.dock,
        // remarks: row.errors?.join('\r\n'),
      };
      // if (normalExport) {
      //   delete newRow['fa_comment'];
      //   delete newRow['remarks'];
      // }

      Object.keys(newRow).forEach((key) => {
        newRow[key] = this.getWrappedColumn(newRow[key]);
      });

      data.push(newRow);
    });

    return data;
  }
  
 
  convertNaN(value) {
    value = Math.round(parseFloat(value?.trim()));
    return isNaN(value) ? '' : value;
  }
  parseUploadedRow = (row) => {
    row = {
      // item_id: row['PartNo']?.trim(),
      kanban: row['kanban'],
      item_id: row['partno'],
      part_description: row['description'],
      tobecounted_date: row['countby'],
      // manually_added: row['man'],
      address: row['pcaddress'],
      order_lot: row['orderlot'],
      boxtype: row['boxtype'],   //BOX TYPE
      apccapacity: row['safety'],
      countboxes: row['countboxes'],  //COUNT BOXES
      container_renban: row['container'],
      module_number: row['module'],
      supplier_code: row['supplier'],
      dock: row['dock'],
    };
  
    // delete row['vanningdate'];
    // delete row['faminoriginal'];
    // delete row['famaxoriginal'];
    // delete row['faminfinal'];
    // delete row['famaxfinal'];

    return row;
  };
  checkIfAll9s(quantity) {
    quantity = '' + quantity;
    const length = quantity.length;

    if (length === 6 && quantity === '999999') {
      return true;
    }

    return false;
  }
  // Validate uploaded file's data
  validateData = (data) => {
    let groupCount = 1;
    let errorCount = 0;

    const validatedData = [];
    data.forEach((row2) => {
      const row = this.parseUploadedRow(row2);
      row.group = [groupCount];
      groupCount++;

      const errors = [];

      // const numericValidationKeys = ['orig_min_qty', 'orig_max_qty', 'rev_max_qty', 'rev_min_qty'];

      // const emptyValidationKeys = [
      //   'vanning_date',
      //   'item_id',
      //   'kanban',
      //   'cont_code',
      //   'order_lot',
      //   ...numericValidationKeys,
      // ];

      // emptyValidationKeys.forEach((key) => {
      //   if (row[key] === undefined || row[key] === '') {
      //     errors.push(`${this.displayNames[key]} cannot be empty.`);
      //   }
      // });

      // numericValidationKeys.forEach((key) => {
      //   if (!/^\d+$/.test(row[key])) {
      //     errors.push(`${this.displayNames[key]} must be an integer.`);
      //   } else if (row[key] < 0 || row[key] > 9999999) {
      //     errors.push(`${this.displayNames[key]} must be between 0 and 9999999.`);
      //   } else {
      //     row[key] = Math.round(parseFloat(row[key]));
      //   }
      // });

      // if (row.orig_min_qty > row.orig_max_qty) {
      //   errors.push(`FA Min Original cannot be greater than FA Max Original.`);
      // }

      // if (row.rev_min_qty > row.rev_max_qty) {
      //   errors.push(`FA Min Final cannot be greater than FA Max Final.`);
      // }

      // let numberIsNotAll9s = !this.checkIfAll9s(row.rev_min_qty);

      // const { order_lot } = row;
      // if (numberIsNotAll9s && row.rev_min_qty % order_lot !== 0) {
      //   errors.push(`FA Min Final must be a multiple of order lot (${order_lot})`);
      // }

      // numberIsNotAll9s = !this.checkIfAll9s(row.rev_max_qty);

      // if (numberIsNotAll9s && row.rev_max_qty % order_lot !== 0) {
      //   errors.push(`FA Max Final must be a multiple of order lot (${order_lot})`);
      // }

      // const vanDate = String(new Date(row.vanning_date));

      // // if (vanDate === 'Invalid Date') {
      // //   errors.push(`Vanning Date must be in MM/DD/YYYY format.`);
      // // } else if (new Date(row.vanning_date) < new Date(this.onInitVanningFrom)) {
      // //   errors.push(`Vanning Date cannot be older than today's vanning date.`);
      // // }

      // const indexes = this.findAllIndexes(data, row, validatedData.length);

      // if (indexes.length > 0) {
      //   errors.push(`Duplicate record(s) found in row(s) ${indexes.join(', ')}`);
      // }

      row.errors = errors;
      errorCount += errors.length;

      validatedData.push(row);
    });
    // const dupdate = this.groupPartsByCount(data, "partno");
    // this.warningMessage = "";
    // this.successMessage = "";
    // let valid = true;
    // if (dupdate && dupdate.length > 0){
    //   valid = false;
    // }
    //this.excelService.uploadedData
    // for (const iterator of dupdate) {
    //   valid = false;
    //   if (!this.warningMessage) {
    //     this.warningMessage = `Duplicate Part No: ${iterator.partno}, Renban: ${iterator.container} & Module: ${iterator.module}.`;
    //   } else {
    //     this.warningMessage += `\nDuplicate Part No: ${iterator.partno}, Renban: ${iterator.container} & Module: ${iterator.module}.`;
    //   }
    // }

    // if (!valid){
    //   return { uploadedData: [], errorCount:1 };
    // }
    return { uploadedData: validatedData, errorCount };
    
  };
  groupPartsByCount(partscountList: any[], prop : any): any[] {
    const countMap: Record<string, any> = {};
  
    partscountList.forEach(item => {
      if(item[prop] && item.container && item.module ){
        const key = `${item[prop]}_${item.container}_${item.module}`;
        if (!countMap[key]) {
          countMap[key] = {
            partno: item[prop],
            container: item.container,
            module: item.module,
            count: 1
          };
        } else {
          countMap[key].count += 1;
        }
      }      
    });
  
    return Object.values(countMap).filter(item => item.count > 1);
  }
  markDuplicates(data) {
    const countMap = {};
  
    // Count occurrences
    data.forEach(item => {
      const key = `${item.item_id}_${item.container_renban}_${item.module_number}`;
      countMap[key] = (countMap[key] || 0) + 1;
    });
  
    // Add status based on count
    return data.map(item => {
      const key = `${item.item_id}`;
      return {
        // ...item,
        key: `Part Number : ${item.item_id}, Renban: ${item.container_renban}, Module: ${item.module_number} is duplicate.`,
        status: countMap[key] > 1 ? "duplicate" : "ok"
      };
    });
  }
  validateDataWithDatabase = () => {
    setTimeout(() => {
      if (this.uploading) {
        this.validateDataWithDatabase();
        return;
      }

      const data = {
        workid: this.user,
        user_role: this.userRole,
        userid: localStorage.getItem('UserName'),
        filter:{
          business_entity:this.namcValue,
          dock:this.exportData[0].dock,
        },
        // business_entity: this.namcValue,
        fileKey: this.fileName,
      };
      
      this.errorDetails = [];
      this.partsCountUserArray = [];
      this.warningMessageUpload = "";
      this.successMessage = "";
      this.partsCountService.uploadPartsCount(data).subscribe({
        error: (error) => this.errorCallback(error,'uploadPartsCount'),
        next: (res) => {
          const { error, details, partsCountUserArray } = res.body;
          // body.details[0].errorDescription
          
      
          if (error) {
            
            // const errorString = details.filter(item => item?.errorStatus === "NOK")
            //   .map(item => `Part No - ${item.partNo}, Kanban- ${item.kanban} : ${item.errorDescription}`)
            //   .join("\n");
              
            // const noErrorStatusString = details
            //   .filter(item => item.errorStatus === undefined)
            //   .map(item => `${item.partNo}/${item.kanban} : 'Uploaded Successfully!'`)
            //   .join("\n");
            // this.timesEditApiCalled = 0;
            // this.editApiStartPosition = 0;
            // this.editApiEndPosition = this.editApiDefaultLimit;

            this.uploadError = true;
            //this.excelService.uploadedData = details;
            this.errorDetails = details;
            this.partsCountUserArray = partsCountUserArray;
            this.uploadEnabled = false;
            // this.rowData = [];

            this.spinner.hide();

            const errorArray = details.filter(item => item?.errorStatus === "NOK")
            if(errorArray && errorArray.length > 0){
              this.warningMessageUpload = "Please download the Excel file and verify the upload status.";
            } 
            else{
              this.successMessage =  successMessage.recordUploaded
            }
            //this.warningMessage = errorString + '\n' +noErrorStatusString;

            // this.uploadToS3();

            // this.validating = false;

            return;
          }else{
            // const noErrorStatusString = details
            //   .filter(item => item.errorStatus === undefined)
            //   .map(item => `Parts No -${item.partNo}, Kanban - ${item.kanban} : 'Uploaded Successfully!'`)
            //   .join("\n");
            //   this.spinner.hide();
            //   this.onSearch(0,true)
            //   this.successMessage =   noErrorStatusString;
            this.spinner.hide();
            this.onSearch(0,true)
            this.successMessage =  successMessage.recordUploaded
            return;
          }

          // this.rowData = [...this.exportData];

          // this.setPageSizeToAll();

          // this.osPartsGrid.gridOptions.api.setRowData(this.rowData);

          // this.headerCheckboxChecked = false;
          // this.osPartsGrid.gridOptions.api.refreshHeader();

          // this.uploadError = false;
          // this.validating = false;
          // this.uploadEnabled = true; // To enable save/cancel button
          // this.editEnabled = false;
          // this.warningMessage = warningMessage.uploadEnabled;

          // setTimeout(() => {
          //   window.scrollTo(0, document.body.scrollHeight);
          //   this.spinner.hide();
          // }, 200);
        },
      });
    }, 1000);
  };
  // findAllIndexes(data, row, index) {
  //   const indexes = [];

  //   for (let i = 0; i < data.length; i++) {
  //     const dataRow = this.parseUploadedRow(data[i]);

  //     if (
  //       dataRow.vanning_date === row.vanning_date &&
  //       dataRow.item_id === row.item_id &&
  //       dataRow.kanban === row.kanban &&
  //       dataRow.cont_code === row.cont_code &&
  //       dataRow.order_lot === row.order_lot &&
  //       i !== index
  //     ) {
  //       indexes.push(i + 2);
  //     }
  //   }
  //   return indexes;
  // }
  validateFile(filename, sizeInBytes) {
    this.uploadError = false;

    this.justFileName = filename;
    this.allowedFilesize = 5000; // Kilobytes

    const allowedFileTypes = ['xlsx', 'xls'];

    const fileType = filename.split('.')[filename.split('.').length - 1];

    const allowedFilesizeInBytes = this.allowedFilesize * 1024;

    if (!allowedFileTypes.includes(fileType)) {
      this.warningMessage = `Only ${allowedFileTypes} files are accepted.`;

      return false;
    }

    if (!(sizeInBytes <= allowedFilesizeInBytes)) {
      this.warningMessage = warningMessage.uploadFileSizeTooBig;

      return false;
    }

    return true;
  }
  @HostListener('drop', ['$event']) onDrop(event) {
    this.onFileChange(event, true);
  }
  onFileChange(event: any, isDrag) {
    this.removeMessage();

    this.spinner.show();

    const file: File = event.target.files.item(0);
    this.actualFileName = file?.name;
    const isFileValid = this.validateFile(file?.name, file?.size);

    if (!isFileValid) {
      this.spinner.hide();
      return;
    }

    setTimeout(() => {
      this.files = [file];
      this.excelService.uploadedFile = file;

      this.fileName = file?.name;

      const target: DataTransfer = (isDrag ? event.dataTransfer : event.target) as DataTransfer;

      const reader: FileReader = new FileReader();

      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, {
          type: 'binary',
          cellDates: true,
          dateNF: 'mm/dd/yyyy;@',
        });


        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /*Remove empty spaces and convert to lower case */
        const range = XLSX.utils.decode_range(ws['!ref']);
        for (let C = range.s.c; C <= range.e.c; C++) {
          const address = `${XLSX.utils.encode_col(C)}1`; // <-- first row
          if (!ws[address]) {
            continue;
          }
          ws[address].w = ws[address].w.replace(/\s/g, '').toLowerCase();
        }

        /* convert to Json */
        this.excelService.uploadedData = XLSX.utils.sheet_to_json(ws, {
          raw: false,
          dateNF: 'mm/dd/yyyy',
        });

        if (this.excelService.uploadedData.length > 400) {
          this.spinner.hide();
          this.warningMessage = warningMessage.partscountUpload;
          this.uploadError = true;
          this.rowData = [];
          this.fileInput.nativeElement.value = null;
          return;
        }

        const { uploadedData, errorCount } = this.validateData(this.excelService.uploadedData);

        this.excelService.uploadedData = uploadedData;

        event.target.value = null; // To clear the uploaded file

        if (uploadedData.length < 1 && errorCount > 0) {
          this.spinner.hide();
          return;
        }

        if (uploadedData.length < 1) {
          this.spinner.hide();
          this.warningMessage = warningMessage.fileEmpty;

          return;
        }

        if (errorCount > 0) {
          this.uploadError = true;
          this.rowData = [];

          this.spinner.hide();
          this.warningMessage = warningMessage.uploadFileError;

          this.uploadToS3();

          return;
        }

        this.exportData = [...uploadedData];
        // console.log(this.exportData,'exportData')
        // console.log(this.exportData[0].dock,'uploadDock')
        // console.log(uploadedData,'uploadedData')
        this.validating = true;
        this.uploadToS3();

        this.validateDataWithDatabase();

        return;
      };
      reader.readAsBinaryString(target.files[0]);
      this.fileInput.nativeElement.value = null;
    }, 1000);
  }
  getFileName() {
    let easternCurrentDate = String(mm().tz('US/Michigan').format('YYYY-MM-DD_HH:mm:ss'));
    const Etimestamp = easternCurrentDate

      .split('.')[0]
      .replace('T', '_')
      .split('')

      .filter((d) => d !== '-' && d !== ':')
      .join('');

    const timestamp = new Date()
      .toISOString()
      .split('.')[0]
      .replace('T', '_')
      .split('')
      .filter((d) => d !== '-' && d !== ':')
      .join('');
    return this.uploadError
      ? `partscount/${this.namcValue}/error/${Etimestamp}.xlsx`
      : `partscount/${this.namcValue}/success/partscount_upload_${timestamp}.xlsx`;
  }
  uploadToS3(): void {
    this.spinner.show();

    const data = this.getExportData();

    this.fileName = this.getFileName();

    this.uploading = true;
    // console.log(this.headersSameAsUI,'headersSameAsUI')
    // console.log(data,'data.......')
    setTimeout(async () => {
      this.fileBuffer = await this.excelService.getFileBuffer(this.exportData, this.fileName, this.headersSameAsUI);

      // this.excelService.readFileBuffer(this.fileBuffer)

      this.uploadExcelDataToS3({ fileName: this.fileName });

      if (this.uploadError) {
        this.spinner.hide();
      }
    }, 100);
  }
  uploadExcelDataToS3({ fileName }) {
    const data = {
      workid: this.user,
      user_role: this.userRole,
      fileName: fileName,
    };
    
    this.flalService.getExcelFileUrl(data).subscribe({
      error: (error) => this.errorCallback(error,'getExcelFileUrl'),
      next: (response) => {
        if (response.body.signedUrl) {
          const a = document.createElement('a');
          a.href = response.body.signedUrl;
          // console.log(this.fileBuffer,'fileBuffer......')
          // const decoder = new TextDecoder('utf-8');  // Assuming the encoding is UTF-8
          // const jsonString = decoder.decode(this.fileBuffer);
          // console.log(jsonString,'jsonString.......')
          this.flalService.putDatainExcel(this.fileBuffer, a.href).subscribe({
            error: (error) => this.errorCallback(error,'putDatainExcel'),
            next: (res) => {
              if (this.uploadEnabled) {
                // this.saveChanges();
              }

              this.uploading = false;
            },
          });
        }
      },
    });
  }
  //template download
  download() {
    this.removeMessage();
    const data = {
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      file_name: 'partscount_template.xlsx',
    };
    this.spinner.show();
    this.partsCountService.getdownloadTemplate(data).subscribe({
      error: (error) => this.errorCallback(error,'getdownloadTemplate'),
      next: (res) => {
        if (res) {
          const a = document.createElement('a');
          a.href = res.body.data;
          a.target = '_blank';
          a.rel = 'noreferrer noopener';

          if (a) {
            window.location.href = a.href;
          }

          this.spinner.hide();
          this.successMessage =  'Parts Count template downloaded successfully!'
        } else {
          this.spinner.hide();
          this.warningMessage = warningMessage.fileNotAvilable;
          window.scroll(0, 0);
        }
      },
    });
  }

  getErrorReport() {
    let easternCurrentDate = String(mm().tz('US/Michigan').format('YYYY-MM-DD_HH:mm:ss'));
    var exportData = [];

    this.excelService.uploadedData.forEach((e) => {
      const obj = {
        kanban: e.kanban,
        item_id: e.item_id,
        part_description: e.part_description,
        count_by: e.tobecounted_date,
        // man: e.manually_added,
        pc_address: e.address,
        order_lot : e.order_lot,
        // boxtype : e.boxtype,
        safety : e.apccapacity,
        countboxes : e.countboxes,
        container_renban : e.container_renban,
        module_number : e.module_number,
        // supplier_code : e.supplier_code,
        dock : e.dock,
        remarks: this.getWrappedColumn1(e.item_id, e.kanban, e.dock, e.countboxes, e.container_renban,  e.module_number),
      };
      exportData.push(obj);
    });
    const headers = ['KANBAN', 'PARTNO', 'DESCRIPTION', 'COUNT BY',
      // 'MAN', 
      'PC ADDRESS', 'ORDERLOT', 'SAFETY','COUNT BOXES',
      'CONTAINER','MODULE','DOCK','COMMENTS'];

    //  //load empty data
    // for (let index = 0; index < 1000; index++) {
    //   const obj = {
    //     item_id: "",
    //     kanban: "",
    //     part_description: "",
    //     count_by: "",
    //     man: "",
    //     pc_address: "",
    //     order_lot: "",
    //     boxtype: "",
    //     safety: "",
    //     countboxes: "",
    //     container_renban: "",
    //     module_number: "",
    //     supplier_code: "",
    //     dock: "",
    //     remarks: "",
    //   };
    //   exportData.push(obj);
    // } 


    const Etimestamp = easternCurrentDate

      .split('.')[0]
      .replace('T', '_')
      .split('')

      .filter((d) => d !== '-' && d !== ':')
      .join('');

    if (exportData.length > 0) {
      this.excelService.exportExcelFileStyle1(
        exportData,
        'partscount_template' + '_' + this.namcName + '_error_' + Etimestamp + '.xlsx',
        headers
      );
  }
}
// PDF export function
private getDataForExport(): any[] {
  const data = [];
  if (this.headerCheckboxChecked) {
    this.osPartsGrid.gridOptions.api.forEachNodeAfterFilter((node) => {
      data.push(node.data); // Gather data for filtered rows
    });
  } else {
    return this.getModifiedRowData(); // Get modified row data if checkbox isn't checked
  }
  return data;
}

// Export to PDF
//PC ADDRESS EXPORT PDF
private prepareExportData(data: any[]): any[] {
  const fieldToHeaderMapping: { [key: string]: string } = {
    item_id: 'PART NUMBER',
    kanban: 'KANBAN',
    part_description: 'DESCRIPTION',
    countboxes: 'COUNT BOXES',
    // 'ORDER LOT' and 'PC ADDRESS' handled separately
  };

  return data.map((e) => {
    const exportObj: any = {};

    // Map standard fields
    Object.keys(fieldToHeaderMapping).forEach((field) => {
      const header = fieldToHeaderMapping[field];
      exportObj[header] = e[field] !== undefined && e[field] !== null ? e[field] : '';
    });

    // Handle ORDER LOT (from order_lot or lotsize)
    exportObj['ORDER LOT'] =
      e['order_lot'] !== undefined && e['order_lot'] !== null
        ? e['order_lot']
        : e['lotsize'] !== undefined && e['lotsize'] !== null
        ? e['lotsize']
        : '';

    // Handle PC ADDRESS (from address or flowrack_address)
    exportObj['PC ADDRESS'] =
      e['address'] !== undefined && e['address'] !== null
        ? e['address']
        // : e['flowrack_address'] !== undefined && e['flowrack_address'] !== null
        // ? e['flowrack_address']
        : '';

    return exportObj;
  });
}


pcAddressExportToPDF(): void {
  this.removeMessage();
  this.spinner.show();

  let data = this.prepareExportData(this.getDataForExport());
  // Sort data by 'PC ADDRESS' (derived from address or flowrack_address)
  data.sort((a, b) => {
    const aAddress = a['PC ADDRESS'] || '';
    const bAddress = b['PC ADDRESS'] || '';
    return aAddress.localeCompare(bAddress);
  });
  if (data.length < 1) {
    this.spinner.hide();
    this.warningMessage = 'No rows selected for export.';
    window.scroll(0, 0);
    return;
  }

  const doc = new jsPDF('landscape');
  const margin = 12;
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;

  const headers = ['PART NUMBER', 'KANBAN',  'DESCRIPTION', 'PC ADDRESS', 'ORDER LOT', 'COUNT BOXES'];

  const columnWidths: { [key: string]: number } = {
    'PART NUMBER': 40,
    'KANBAN': 20,
    'DESCRIPTION': 120,       // More space for Description
    'PC ADDRESS': 40,
    'ORDER LOT': 30,
    'COUNT BOXES': 30
  };

  const totalTableWidth = Object.values(columnWidths).reduce((a, b) => a + b, 0);

  const now = new Date();
  const pageDate = now.toLocaleString('en-US', { timeZoneName: 'short' });

  let pageNumber = 1;

  // Draw table header row
  const drawTableHeader = (doc: jsPDF, y: number): number => {
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);

    let x = margin;
    headers.forEach(header => {
      doc.text(header, x, y);
      x += columnWidths[header];
    });

    y += 2;
    doc.setLineWidth(0.8);
    doc.line(margin, y, margin + totalTableWidth, y);
    return y + 5;
  };

  // Draw footer
  const drawFooter = (doc: jsPDF, pageNum: number) => {
    const footerText = `${pageDate} - page ${pageNum}`;
    doc.setFontSize(8);
    doc.setFont('helvetica', 'bold');
    const textWidth = doc.getTextWidth(footerText);
    doc.text(footerText, (pageWidth - textWidth) / 2, pageHeight - 5);
  };

  let yPosition = 20;

  // Draw "NEXT CONTAINER..." only on first page
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(12);
  doc.text('Parts Counts', margin, yPosition);
  yPosition += 10;
  doc.text('NEXT CONTAINER: ......................................................... MODULE: .........................................................', margin, yPosition);
  yPosition += 10;

  // Draw table headers
  yPosition = drawTableHeader(doc, yPosition);

  // Start rows
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  data.forEach((row, rowIndex) => {
    // Check for page overflow
    if (yPosition + 10 > pageHeight - 15) {
      drawFooter(doc, pageNumber);
      doc.addPage();
      pageNumber++;
      yPosition = 20;
  
      // Redraw table headers on new page
      yPosition = drawTableHeader(doc, yPosition);
    }
  
    const rowHeight = 10;
  
    // 🔹 Alternate row background
    if (rowIndex % 2 === 1) {
      doc.setFillColor(230, 230, 230); // Light gray
      doc.rect(margin, yPosition - 7, totalTableWidth, rowHeight, 'F');
    }
  
    // Draw data row text
    let x = margin;
    headers.forEach(header => {
      const value = row[header] !== undefined ? row[header] : 'N/A';
      doc.text(String(value), x, yPosition);
      x += columnWidths[header];
    });
  
    yPosition += rowHeight;
  });
  
  // Draw footer on the last page
  drawFooter(doc, pageNumber);

  const timestamp = mm().tz('US/Michigan').format('YYYYMMDD_HHmmss');
  doc.save(`Parts-count_${timestamp}.pdf`);
  this.spinner.hide();
}
//LS ADDRESS EXPORT PDF 
private kanbanLSprepareExportData(data: any[]): any[] {
  // Define the field to header mapping, excluding 'order_lot' (handled manually)
  const fieldToHeaderMapping: { [key: string]: string } = {
    item_id: 'PART NUMBER',
    kanban: 'KANBAN',
    part_description: 'DESCRIPTION',
    line_side_address: 'LINESIDE ADDRESS',
    countboxes: 'COUNT BOXES',
  };

  return data.map((e) => {
    const exportObj: any = {};

    // Map standard fields
    Object.keys(fieldToHeaderMapping).forEach((field) => {
      const header = fieldToHeaderMapping[field];
      exportObj[header] = e[field] !== undefined && e[field] !== null ? e[field] : '';
    });

    // Manually set 'ORDER LOT' using order_lot or fallback to lotsize
    exportObj['ORDER LOT'] =
      e['order_lot'] !== undefined && e['order_lot'] !== null
        ? e['order_lot']
        : e['lotsize'] !== undefined && e['lotsize'] !== null
        ? e['lotsize']
        : '';

    return exportObj;
  });
}
prepareAndExportLSKanban(): void {
  this.lsAddressExportToPrint(true); // true = tell it to trigger export when done
}
lsAddressExportToPrint(triggeringExport = false) {
  this.spinner.show();

  const data = {
    business_entity: this.namcValue,
    workid: this.user,
    user_role: this.userRole,
    dock:this.selectedDock.dock
  };

  this.partsCountService.lineSideAddress(data)?.subscribe({
    error: (error) => {
      this.spinner.hide();
      this.errorCallback(error, 'lineSideAddress');
    },
    next: (res) => {
      const apiData = res?.body.data;
      if (!Array.isArray(apiData) || apiData.length === 0) {
        this.spinner.hide();
        this.warningMessage = 'No LS Address data available.';
        return;
      }

      // Step 1: Create map of item_id -> Set of line_side_address
      const addressMap = new Map<string, Set<string>>();
      for (const item of apiData) {
        const itemId = item.item_id?.trim();
        const address = item.line_side_address?.trim();
        if (!itemId || !address) continue;

        if (!addressMap.has(itemId)) {
          addressMap.set(itemId, new Set());
        }
        addressMap.get(itemId)?.add(address);
      }

      // Step 2: Update rowData based on map
      this.rowData = this.rowData.map(row => {
        const itemId = row.item_id?.trim();
        if (addressMap.has(itemId)) {
          const uniqueAddresses = Array.from(addressMap.get(itemId)!);
          return {
            ...row,
            // line_side_address: uniqueAddresses.join(', '), // combine addresses
            // line_side_address: uniqueAddresses.join('\n') // for line breaks
            line_side_address: uniqueAddresses.length === 1
              ? uniqueAddresses[0] + '\n' // Add trailing comma and line break
              : uniqueAddresses.map((a, i, arr) =>
                i < arr.length - 1 ? a + ',' : a
            ).join('\n')
          
          };
        } else {
          return {
            ...row,
            line_side_address: '\n', // or null if you prefer
          };
        }
      });

      // Step 3: Refresh the grid and log
      this.osPartsGrid.gridOptions?.api?.setRowData(this.rowData);

      console.log('Updated rowData with line_side_address:', this.rowData);

      this.spinner.hide();
      this.setPageSizeToAll();
      if (triggeringExport) {
        this.lsTotalKanbanAddressExportToPDF();
      }

    }
  });
}
lsTotalKanbanAddressExportToPDF(): void {
  this.removeMessage();
  this.spinner.show();

  let data = this.kanbanLSprepareExportData(this.getDataForExport());
  data.sort((a, b) => {
    const aAddress = a['LINESIDE ADDRESS'] || '';
    const bAddress = b['LINESIDE ADDRESS'] || '';
    return aAddress.localeCompare(bAddress);
  });
  if (data.length < 1) {
    this.spinner.hide();
    this.warningMessage = 'No rows selected for export.';
    window.scroll(0, 0);
    return;
  }

  const doc = new jsPDF('landscape');
  const margin = 12;
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;

  const headers = ['PART NUMBER', 'KANBAN', 'DESCRIPTION', 'LINESIDE ADDRESS', 'ORDER LOT', 'COUNT BOXES'];

  const columnWidths: { [key: string]: number } = {
    'PART NUMBER': 40,
    'KANBAN': 20,
    'DESCRIPTION': 120,       // More space for Description
    'LINESIDE ADDRESS': 40,
    'ORDER LOT': 30,
    'COUNT BOXES': 30
  };

  const totalTableWidth = Object.values(columnWidths).reduce((a, b) => a + b, 0);

  const now = new Date();
  const pageDate = now.toLocaleString('en-US', { timeZoneName: 'short' });

  let pageNumber = 1;

  // Draw table header row
  const drawTableHeader = (doc: jsPDF, y: number): number => {
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);

    let x = margin;
    headers.forEach(header => {
      doc.text(header, x, y);
      x += columnWidths[header];
    });

    y += 2;
    doc.setLineWidth(0.8);
    doc.line(margin, y, margin + totalTableWidth, y);
    return y + 5;
  };

  // Draw footer
  const drawFooter = (doc: jsPDF, pageNum: number) => {
    const footerText = `${pageDate} - page ${pageNum}`;
    doc.setFontSize(8);
    doc.setFont('helvetica', 'bold');
    const textWidth = doc.getTextWidth(footerText);
    doc.text(footerText, (pageWidth - textWidth) / 2, pageHeight - 5);
  };

  let yPosition = 20;

  // Draw "NEXT CONTAINER..." only on first page
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(12);
  doc.text('Parts Counts', margin, yPosition);
  yPosition += 10;
  doc.text('NEXT CONTAINER: ......................................................... MODULE: .........................................................', margin, yPosition);
  yPosition += 10;

  // Draw table headers
  yPosition = drawTableHeader(doc, yPosition);

  // Start rows
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  data.forEach((row, rowIndex) => {
    const rowLines: { [key: string]: string[] } = {};
    let maxLines = 1;
  
    headers.forEach(header => {
      const value = row[header] !== undefined ? String(row[header]) : 'N/A';
      const wrappedLines = doc.splitTextToSize(value, columnWidths[header]);
      rowLines[header] = wrappedLines;
      maxLines = Math.max(maxLines, wrappedLines.length);
    });
  
    const rowHeight = maxLines * 5;
  
    if (yPosition + rowHeight > pageHeight - 15) {
      drawFooter(doc, pageNumber);
      doc.addPage();
      pageNumber++;
      yPosition = 20;
      yPosition = drawTableHeader(doc, yPosition);
    }
  
    if (rowIndex % 2 === 1) {
      doc.setFillColor(230, 230, 230);
      doc.rect(margin, yPosition - 4, totalTableWidth, rowHeight, 'F');
    }
  
    let x = margin;
    headers.forEach(header => {
      doc.text(rowLines[header], x, yPosition);
      x += columnWidths[header];
    });
  
    yPosition += rowHeight;
  });
  
  // Draw footer on the last page
  drawFooter(doc, pageNumber);

  const timestamp = mm().tz('US/Michigan').format('YYYYMMDD_HHmmss');
  doc.save(`Parts-count_${timestamp}.pdf`);
  this.spinner.hide();
}
//LS ADDRESS/KANBAN EXPORT PDF 
private prePareExportData(data: any[]): any[] {
  const fieldToHeaderMapping: { [key: string]: string } = {
    item_id: 'PART NUMBER',
    kanban: 'KANBAN',
    part_description: 'DESCRIPTION',
    lineside_address: 'LINESIDE ADDRESS',
    countboxes: 'COUNT BOXES',
    // 'ORDER LOT' handled separately
  };

  return data.map((e) => {
    const exportObj: any = {};

    // Map standard fields
    Object.keys(fieldToHeaderMapping).forEach((field) => {
      const header = fieldToHeaderMapping[field];
      exportObj[header] = e[field] !== undefined && e[field] !== null ? e[field] : '';
    });

    // Handle 'ORDER LOT' using either order_lot or lotsize
    exportObj['ORDER LOT'] =
      e['order_lot'] !== undefined && e['order_lot'] !== null
        ? e['order_lot']
        : e['lotsize'] !== undefined && e['lotsize'] !== null
        ? e['lotsize']
        : '';

    return exportObj;
  });
}

prepareAndExportLS(): void {
  this.lineSideAddress(true); // true = tell it to trigger export when done
}
lineSideAddress(triggerExport = false) {
  this.removeMessage();
  this.spinner.show();
  const data = {
    business_entity: this.namcValue,
    workid: this.user,
    user_role: this.userRole,
    dock:this.selectedDock.dock
  };

  this.partsCountService.lineSideAddress(data)?.subscribe({
    error: (error) => {
      this.spinner.hide();
      this.errorCallback(error, 'lineSideAddress');
    },
    next: (res) => {
      const responseBody = res.body.data;

      if (!responseBody || !Array.isArray(responseBody) || responseBody.length === 0) {
        this.spinner.hide();
        this.warningMessage = 'No data available from line side address API.';
        window.scroll(0, 0);
        return;
      }

      // Step 1: Create map of item_id → Set of line_side_address
      const addressMap = new Map<string, Set<string>>();
      responseBody.forEach(entry => {
        const itemId = (entry.item_id || '').trim();
        const address = (entry.line_side_address || '').trim();

        if (!itemId || !address) return;

        if (!addressMap.has(itemId)) {
          addressMap.set(itemId, new Set());
        }
        addressMap.get(itemId)!.add(address);
      });

      // Step 2: Duplicate rows for each unique address
      const expandedRows: any[] = [];
      this.tempRowData = [...this.rowData]
      this.rowData.forEach(row => {
        const itemId = (row.item_id || '').trim();
        const addresses = addressMap.get(itemId);

        if (addresses && addresses.size > 0) {
          addresses.forEach(addr => {
            expandedRows.push({
              ...row,
              lineside_address: addr + '\n'  // Always add comma + line break
            });
          });
        } else {
          expandedRows.push({
            ...row,
            lineside_address: ''
          });
        }
      });
      // this.setPageSizeToAll();
      this.rowData =  expandedRows;

      this.osPartsGrid.gridOptions?.api?.setRowData(this.rowData);
      if (triggerExport) {
        this.lsAddressExportToPDF();
      }
      this.rowData =  this.tempRowData;

      this.osPartsGrid.gridOptions?.api?.setRowData(this.rowData);
      // console.log("Updated rowData:", this.rowData);

      this.spinner.hide();
    },
  });
}

lsAddressExportToPDF(): void {
  this.removeMessage();
  this.spinner.show();

  let data = this.prePareExportData(this.getDataForExport());
  data.sort((a, b) => {
    const aAddress = a['LINESIDE ADDRESS'] || '';
    const bAddress = b['LINESIDE ADDRESS'] || '';
    return aAddress.localeCompare(bAddress);
  });
  if (data.length < 1) {
    this.spinner.hide();
    this.warningMessage = 'No rows selected for export.';
    window.scroll(0, 0);
    return;
  }

  const doc = new jsPDF('landscape');
  const margin = 12;
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;

  const headers = ['PART NUMBER', 'KANBAN', 'DESCRIPTION', 'LINESIDE ADDRESS', 'ORDER LOT', 'COUNT BOXES'];

  const columnWidths: { [key: string]: number } = {
    'PART NUMBER': 40,
    'KANBAN': 20,
    'DESCRIPTION': 120,       // More space for Description
    'LINESIDE ADDRESS': 40,
    'ORDER LOT': 30,
    'COUNT BOXES': 30
  };

  const totalTableWidth = Object.values(columnWidths).reduce((a, b) => a + b, 0);

  const now = new Date();
  const pageDate = now.toLocaleString('en-US', { timeZoneName: 'short' });

  let pageNumber = 1;

  // Draw table header row
  const drawTableHeader = (doc: jsPDF, y: number): number => {
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);

    let x = margin;
    headers.forEach(header => {
      doc.text(header, x, y);
      x += columnWidths[header];
    });

    y += 2;
    doc.setLineWidth(0.8);
    doc.line(margin, y, margin + totalTableWidth, y);
    return y + 5;
  };

  // Draw footer
  const drawFooter = (doc: jsPDF, pageNum: number) => {
    const footerText = `${pageDate} - page ${pageNum}`;
    doc.setFontSize(8);
    doc.setFont('helvetica', 'bold');
    const textWidth = doc.getTextWidth(footerText);
    doc.text(footerText, (pageWidth - textWidth) / 2, pageHeight - 5);
  };

  let yPosition = 20;

  // Draw "NEXT CONTAINER..." only on first page
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(12);
  doc.text('Parts Counts', margin, yPosition);
  yPosition += 10;
  doc.text('NEXT CONTAINER: ......................................................... MODULE: .........................................................', margin, yPosition);
  yPosition += 10;

  // Draw table headers
  yPosition = drawTableHeader(doc, yPosition);

  // Start rows
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  data.forEach((row, rowIndex) => {
    // Check for page overflow
    if (yPosition + 10 > pageHeight - 15) {
      drawFooter(doc, pageNumber);
      doc.addPage();
      pageNumber++;
      yPosition = 20;
  
      // Redraw table headers on new page
      yPosition = drawTableHeader(doc, yPosition);
    }
  
    const rowHeight = 10;
  
    // Alternate row background
    if (rowIndex % 2 === 1) {
      doc.setFillColor(230, 230, 230); // Light gray
      doc.rect(margin, yPosition - 7, totalTableWidth, rowHeight, 'F');
    }
  
    // Draw data row text
    let x = margin;
    headers.forEach(header => {
      const value = row[header] !== undefined ? row[header] : 'N/A';
      doc.text(String(value), x, yPosition);
      x += columnWidths[header];
    });
  
    yPosition += rowHeight;
  });

  // Draw footer on the last page
  drawFooter(doc, pageNumber);

  const timestamp = mm().tz('US/Michigan').format('YYYYMMDD_HHmmss');
  doc.save(`Parts-count_${timestamp}.pdf`);
  this.spinner.hide();
}
lsKanbanAddressExportToPDF(): void {
  this.removeMessage();
  this.spinner.show();

  let data = this.prePareExportData(this.getDataForExport());

  if (data.length < 1) {
    this.spinner.hide();
    this.warningMessage = 'No rows selected for export.';
    window.scroll(0, 0);
    return;
  }

  const doc = new jsPDF('landscape');
  const margin = 12;
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;

  const headers = ['PART NUMBER', 'KANBAN', 'DESCRIPTION', 'LINESIDE ADDRESS', 'ORDER LOT', 'COUNT BOXES'];

  const columnWidths: { [key: string]: number } = {
    'PART NUMBER': 40,
    'KANBAN': 20,
    'DESCRIPTION': 120,       // More space for Description
    'LINESIDE ADDRESS': 40,
    'ORDER LOT': 30,
    'COUNT BOXES': 30
  };

  const totalTableWidth = Object.values(columnWidths).reduce((a, b) => a + b, 0);

  const now = new Date();
  const pageDate = now.toLocaleString('en-US', { timeZoneName: 'short' });

  let pageNumber = 1;

  // Draw table header row
  const drawTableHeader = (doc: jsPDF, y: number): number => {
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);

    let x = margin;
    headers.forEach(header => {
      doc.text(header, x, y);
      x += columnWidths[header];
    });

    y += 2;
    doc.setLineWidth(0.8);
    doc.line(margin, y, margin + totalTableWidth, y);
    return y + 5;
  };

  // Draw footer
  const drawFooter = (doc: jsPDF, pageNum: number) => {
    const footerText = `${pageDate} - page ${pageNum}`;
    doc.setFontSize(8);
    doc.setFont('helvetica', 'bold');
    const textWidth = doc.getTextWidth(footerText);
    doc.text(footerText, (pageWidth - textWidth) / 2, pageHeight - 5);
  };

  let yPosition = 20;

  // Draw "NEXT CONTAINER..." only on first page
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(12);
  doc.text('Parts Counts', margin, yPosition);
  yPosition += 10;
  doc.text('NEXT CONTAINER: ......................................................... MODULE: .........................................................', margin, yPosition);
  yPosition += 10;

  // Draw table headers
  yPosition = drawTableHeader(doc, yPosition);

  // Start rows
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  data.forEach((row, rowIndex) => {
    // Check for page overflow
    if (yPosition + 10 > pageHeight - 15) {
      drawFooter(doc, pageNumber);
      doc.addPage();
      pageNumber++;
      yPosition = 20;
  
      // Redraw table headers on new page
      yPosition = drawTableHeader(doc, yPosition);
    }
  
    const rowHeight = 10;
  
    // Alternate row background
    if (rowIndex % 2 === 1) {
      doc.setFillColor(230, 230, 230); // Light gray
      doc.rect(margin, yPosition - 7, totalTableWidth, rowHeight, 'F');
    }
  
    // Draw data row text
    let x = margin;
    headers.forEach(header => {
      const value = row[header] !== undefined ? row[header] : 'N/A';
      doc.text(String(value), x, yPosition);
      x += columnWidths[header];
    });
  
    yPosition += rowHeight;
  });
  // Draw footer on the last page
  drawFooter(doc, pageNumber);

  const timestamp = mm().tz('US/Michigan').format('YYYYMMDD_HHmmss');
  doc.save(`Parts-count_${timestamp}.pdf`);
  this.spinner.hide();
}
//PC & LS ADDRESS EXPORT PDF 
private pcLSprepareExportData(data: any[]): any[] {
  // Define the field-to-header mapping (exclude order_lot and address, handled manually)
  const fieldToHeaderMapping: { [key: string]: string } = {
    item_id: 'PART NUMBER',
    kanban: 'KANBAN',
    part_description: 'DESCRIPTION',
    lineside_address: 'LINESIDE ADDRESS',
    countboxes: 'COUNT BOXES',
  };

  return data.map((e) => {
    const exportObj: any = {};

    // Map standard fields
    Object.keys(fieldToHeaderMapping).forEach((field) => {
      const header = fieldToHeaderMapping[field];
      exportObj[header] = e[field] !== undefined && e[field] !== null ? e[field] : '';
    });

    // Set 'ORDER LOT' from order_lot or fallback to lotsize
    exportObj['ORDER LOT'] =
      e['order_lot'] !== undefined && e['order_lot'] !== null
        ? e['order_lot']
        : e['lotsize'] !== undefined && e['lotsize'] !== null
        ? e['lotsize']
        : '';

    // Set 'PC ADDRESS' from address or fallback to flowrack_address
    exportObj['PC ADDRESS'] =
      e['address'] !== undefined && e['address'] !== null
        ? e['address']
        // : e['flowrack_address'] !== undefined && e['flowrack_address'] !== null
        // ? e['flowrack_address']
        : '';

    return exportObj;
  });
}

pcLineSideAddress(triggerExport = false) {
  this.removeMessage();
  this.spinner.show();
  const data = {
    business_entity: this.namcValue,
    workid: this.user,
    user_role: this.userRole,
    dock:this.selectedDock.dock
  };

  this.partsCountService.lineSideAddress(data)?.subscribe({
    error: (error) => {
      this.spinner.hide();
      this.errorCallback(error, 'lineSideAddress');
    },
    next: (res) => {
      const responseBody = res.body.data;

      if (!responseBody || !Array.isArray(responseBody) || responseBody.length === 0) {
        this.spinner.hide();
        this.warningMessage = 'No data available from line side address API.';
        window.scroll(0, 0);
        return;
      }

      // Step 1: Create map of item_id → Set of line_side_address
      const addressMap = new Map<string, Set<string>>();
      responseBody.forEach(entry => {
        const itemId = (entry.item_id || '').trim();
        const address = (entry.line_side_address || '').trim();

        if (!itemId || !address) return;

        if (!addressMap.has(itemId)) {
          addressMap.set(itemId, new Set());
        }
        addressMap.get(itemId)!.add(address);
      });

      // Step 2: Duplicate rows for each unique address
      const expandedRows: any[] = [];
      this.tempRowData = [...this.rowData]
      this.rowData.forEach(row => {
        const itemId = (row.item_id || '').trim();
        const addresses = addressMap.get(itemId);

        if (addresses && addresses.size > 0) {
          addresses.forEach(addr => {
            expandedRows.push({
              ...row,
              lineside_address: addr + '\n'  // Always add comma + line break
            });
          });
        } else {
          expandedRows.push({
            ...row,
            lineside_address: ''
          });
        }
      });

      
      // this.setPageSizeToAll();
      this.rowData =  expandedRows;

      this.osPartsGrid.gridOptions?.api?.setRowData(this.rowData);
      if (triggerExport) {
        this.pcLsAddressExportToPDF();
      }
      this.rowData =  this.tempRowData;

      this.osPartsGrid.gridOptions?.api?.setRowData(this.rowData);
      // console.log("Updated rowData:", this.rowData);

      this.spinner.hide();
    },
  });
}
pcLsAddressExportToPDF(): void {
  this.removeMessage();
  this.spinner.show();

  let data = this.pcLSprepareExportData(this.getDataForExport());
  data.sort((a, b) => {
    const aAddress = a['PC ADDRESS'] || '';
    const bAddress = b['PC ADDRESS'] || '';
    return aAddress.localeCompare(bAddress);
  });
  if (data.length < 1) {
    this.spinner.hide();
    this.warningMessage = 'No rows selected for export.';
    window.scroll(0, 0);
    return;
  }

  const doc = new jsPDF('landscape');
  const margin = 12;
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;

  const headers = ['PART NUMBER', 'KANBAN', 'DESCRIPTION', 'PC ADDRESS', 'LINESIDE ADDRESS', 'ORDER LOT', 'COUNT BOXES'];

  const columnWidths: { [key: string]: number } = {
    'PART NUMBER': 30,
    'KANBAN': 20,
    'DESCRIPTION': 100,       // More space for Description
    'PC ADDRESS': 30,
    'LINESIDE ADDRESS': 40,
    'ORDER LOT': 25,
    'COUNT BOXES': 25
  };

  const totalTableWidth = Object.values(columnWidths).reduce((a, b) => a + b, 0);

  const now = new Date();
  const pageDate = now.toLocaleString('en-US', { timeZoneName: 'short' });

  let pageNumber = 1;

  // Draw table header row
  const drawTableHeader = (doc: jsPDF, y: number): number => {
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);

    let x = margin;
    headers.forEach(header => {
      doc.text(header, x, y);
      x += columnWidths[header];
    });

    y += 2;
    doc.setLineWidth(0.8);
    doc.line(margin, y, margin + totalTableWidth, y);
    return y + 5;
  };

  // Draw footer
  const drawFooter = (doc: jsPDF, pageNum: number) => {
    const footerText = `${pageDate} - page ${pageNum}`;
    doc.setFontSize(8);
    doc.setFont('helvetica', 'bold');
    const textWidth = doc.getTextWidth(footerText);
    doc.text(footerText, (pageWidth - textWidth) / 2, pageHeight - 5);
  };

  let yPosition = 20;

  // Draw "NEXT CONTAINER..." only on first page
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(12);
  doc.text('Parts Counts', margin, yPosition);
  yPosition += 10;
  doc.text('NEXT CONTAINER: ......................................................... MODULE: .........................................................', margin, yPosition);
  yPosition += 10;

  // Draw table headers
  yPosition = drawTableHeader(doc, yPosition);

  // Start rows
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  data.forEach((row, rowIndex) => {
    // Check for page overflow
    if (yPosition + 10 > pageHeight - 15) {
      drawFooter(doc, pageNumber);
      doc.addPage();
      pageNumber++;
      yPosition = 20;
  
      // Redraw table headers on new page
      yPosition = drawTableHeader(doc, yPosition);
    }
  
    const rowHeight = 10;
  
    // 🔹 Alternate row background
    if (rowIndex % 2 === 1) {
      doc.setFillColor(230, 230, 230); // Light gray
      doc.rect(margin, yPosition - 7, totalTableWidth, rowHeight, 'F');
    }
  
    // Draw data row text
    let x = margin;
    headers.forEach(header => {
      const value = row[header] !== undefined ? row[header] : 'N/A';
      doc.text(String(value), x, yPosition);
      x += columnWidths[header];
    });
  
    yPosition += rowHeight;
  });
  
  // Draw footer on the last page
  drawFooter(doc, pageNumber);

  const timestamp = mm().tz('US/Michigan').format('YYYYMMDD_HHmmss');
  doc.save(`Parts-count_${timestamp}.pdf`);
  this.spinner.hide();
}
pcLsAddressExportToPrint(): void {
  this.pcLineSideAddress(true); // true = tell it to trigger export when done
}

getCurrentDate(addDashes: boolean) {
  if (addDashes){
    return mm().tz('America/New_York').format('YYYY-MM-DD');
  }else{
    return mm().tz('America/New_York').format('YYYYMMDD');
  }
}

}
